import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import _32x151 from "./32x151.png";
import _32x152 from "./32x152.png";
import _32x153 from "./32x153.png";

const width = '100%'
const height = 'auto'
const viewBox = '0 0 918 287'

const getDimensions = (size, sizes) => {
  if (size && typeof size.width === 'number' && typeof size.height === 'number') {
    return size
  }
  return size && sizes[size]
    ? sizes[size]
    : { width, height }
}

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) { return '' }
  const dimensions = getDimensions(size, sizes)
  const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : ''
  return css`
    width: ${dimensions.width};
    height: ${dimensions.height};
    ${fillRule}
  `
}

const propsToCss = ({
  size,
  sizes,
  fillColor,
  fillColorRule,
  noStyles
}) => getCss(size, sizes, fillColor, fillColorRule, noStyles)

const Image = styled.svg`${propsToCss}`

const children = (
  <Fragment>
    <defs
      key='key-0'
    >
      <linearGradient
        id='s-68ff652d2d-a'
        x1='-2402.49'
        x2='-2402.24'
        y1='318.67'
        y2='318.67'
        gradientTransform='matrix(-1 0 0 1 -2173.39 -239.04)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#595959'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#5c5c5c'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-h'
        x1='-2401.3'
        x2='-2401.05'
        y1='318.61'
        y2='318.61'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-i'
        x1='-2400.19'
        x2='-2399.94'
        y1='318.55'
        y2='318.55'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-j'
        x1='-2399.08'
        x2='-2398.83'
        y1='318.47'
        y2='318.47'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-k'
        x1='-2397.89'
        x2='-2397.64'
        y1='318.4'
        y2='318.4'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-l'
        x1='-2396.78'
        x2='-2396.53'
        y1='318.34'
        y2='318.34'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-m'
        x1='-2395.66'
        x2='-2395.41'
        y1='318.27'
        y2='318.27'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-n'
        x1='-2394.47'
        x2='-2394.22'
        y1='318.2'
        y2='318.2'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-o'
        x1='-2393.35'
        x2='-2393.1'
        y1='318.13'
        y2='318.13'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-p'
        x1='-2392.25'
        x2='-2392'
        y1='318.07'
        y2='318.07'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-q'
        x1='-2391.06'
        x2='-2390.81'
        y1='318.03'
        y2='318.03'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-r'
        x1='-2389.94'
        x2='-2389.69'
        y1='317.91'
        y2='317.91'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-s'
        x1='-2388.87'
        x2='-2388.62'
        y1='317.84'
        y2='317.84'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-t'
        x1='-2387.68'
        x2='-2387.43'
        y1='317.81'
        y2='317.81'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-u'
        x1='-2386.57'
        x2='-2386.32'
        y1='317.75'
        y2='317.75'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-v'
        x1='-2405.99'
        x2='-2389.71'
        y1='307.62'
        y2='307.62'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-w'
        x1='-2405.98'
        x2='-2389.7'
        y1='306.17'
        y2='306.17'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-x'
        x1='-2405.98'
        x2='-2389.7'
        y1='304.79'
        y2='304.79'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-y'
        x1='-2405.97'
        x2='-2389.69'
        y1='303.33'
        y2='303.33'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-z'
        x1='-2405.97'
        x2='-2389.69'
        y1='301.95'
        y2='301.95'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-A'
        x1='-2406.1'
        x2='-2389.82'
        y1='337.31'
        y2='337.31'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-B'
        x1='-2406.1'
        x2='-2389.82'
        y1='338.52'
        y2='338.52'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-C'
        x1='-2406.09'
        x2='-2389.81'
        y1='335.93'
        y2='335.93'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-D'
        x1='-2406.09'
        x2='-2389.81'
        y1='334.48'
        y2='334.48'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-E'
        x1='-2406.08'
        x2='-2389.8'
        y1='333.1'
        y2='333.1'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-F'
        x1='-2406.08'
        x2='-2389.8'
        y1='331.64'
        y2='331.64'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-G'
        x1='-2406.07'
        x2='-2389.79'
        y1='330.26'
        y2='330.26'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-H'
        x1='-2406.06'
        x2='-2389.79'
        y1='328.81'
        y2='328.81'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-I'
        x1='-2406.06'
        x2='-2389.78'
        y1='327.43'
        y2='327.43'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-J'
        x1='-2406.05'
        x2='-2389.78'
        y1='325.97'
        y2='325.97'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-K'
        x1='-2406.05'
        x2='-2389.77'
        y1='324.56'
        y2='324.56'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-L'
        x1='-2406.04'
        x2='-2389.77'
        y1='323.1'
        y2='323.1'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-M'
        x1='-2406.04'
        x2='-2389.76'
        y1='321.72'
        y2='321.72'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-N'
        x1='-2406.03'
        x2='-2389.76'
        y1='320.27'
        y2='320.27'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-O'
        x1='-2406.03'
        x2='-2389.75'
        y1='318.88'
        y2='318.88'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-P'
        x1='-2406.02'
        x2='-2389.75'
        y1='317.43'
        y2='317.43'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-Q'
        x1='-2406.02'
        x2='-2389.74'
        y1='316.05'
        y2='316.05'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-R'
        x1='-2406.01'
        x2='-2389.73'
        y1='314.59'
        y2='314.59'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-S'
        x1='-2406.01'
        x2='-2389.73'
        y1='313.21'
        y2='313.21'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-T'
        x1='-2406'
        x2='-2389.72'
        y1='311.76'
        y2='311.76'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-U'
        x1='-2406'
        x2='-2389.72'
        y1='310.38'
        y2='310.38'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-V'
        x1='-2405.99'
        x2='-2389.71'
        y1='308.92'
        y2='308.92'
        gradientTransform='matrix(-.99 0 0 1 -2160.37 -231.52)'
        xlinkHref='#s-68ff652d2d-a'
      />
      <linearGradient
        id='s-68ff652d2d-W'
        x1='211.45'
        x2='230.55'
        y1='78.6'
        y2='78.6'
        xlinkHref='#s-68ff652d2d-a'
      />
      <radialGradient
        id='s-68ff652d2d-X'
        cx='214.86'
        cy='75.35'
        r='1.36'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </radialGradient>
      <linearGradient
        id='s-68ff652d2d-Y'
        x1='267.25'
        x2='267.27'
        y1='314.8'
        y2='314.28'
        gradientTransform='matrix(1.11 .01 .01 1 -81.72 -240.56)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-b'
        x1='499.14'
        x2='501.64'
        y1='119.78'
        y2='119.78'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#333'
        />
        <stop
          offset='.51'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#333'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-f'
        x1='457.09'
        x2='496.25'
        y1='139.36'
        y2='139.36'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#e6e6e6'
        />
        <stop
          offset='1'
          stopColor='#f2f2f2'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-Z'
        x1='448.47'
        x2='450.97'
        y1='187.63'
        y2='187.63'
        xlinkHref='#s-68ff652d2d-b'
      />
      <linearGradient
        id='s-68ff652d2d-aa'
        x1='1979.93'
        x2='1980.19'
        y1='739.55'
        y2='739.04'
        gradientTransform='rotate(-27.38 391.605 3461.088)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#d45a24'
        />
        <stop
          offset='.84'
          stopColor='#a2272d'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-ab'
        x1='736.53'
        x2='736.99'
        y1='1016.57'
        y2='1016.73'
        gradientTransform='matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#f15a24'
        />
        <stop
          offset='.83'
          stopColor='#a6272d'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-c'
        x1='548.32'
        x2='548.51'
        y1='312.89'
        y2='312.89'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#be1e2d'
        />
        <stop
          offset='1'
          stopColor='#ee4036'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-ac'
        x1='546.5'
        x2='557.07'
        y1='314.15'
        y2='314.15'
        xlinkHref='#s-68ff652d2d-c'
      />
      <linearGradient
        id='s-68ff652d2d-d'
        x1='-1579.73'
        x2='-1573.43'
        y1='333.28'
        y2='333.28'
        gradientTransform='matrix(-1 0 0 1 -1372.33 0)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#d45a24'
        />
        <stop
          offset='1'
          stopColor='#a2272d'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-e'
        x1='-1605.08'
        x2='-1603.5'
        y1='212.12'
        y2='212.12'
        gradientTransform='matrix(-.99 -.11 -.11 .99 -1367.89 -60.26)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#f15a24'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-ad'
        x1='202.79'
        x2='202.96'
        y1='333.11'
        y2='333.11'
        xlinkHref='#s-68ff652d2d-c'
      />
      <linearGradient
        id='s-68ff652d2d-ae'
        x1='201.11'
        x2='210.82'
        y1='334.22'
        y2='334.22'
        xlinkHref='#s-68ff652d2d-c'
      />
      <clipPath
        id='s-68ff652d2d-af'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M904.05 361.43c0 .16 0 .32-.07.48h-.62c0-.16 0-.32.07-.48h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ag'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M904.05 361.43h-.62c.06-.4.12-.79.2-1.15h.62c-.07.36-.14.72-.2 1.15z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ah'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M903.44 362.65h-.1c.08-.69.19-1.38.31-2h.62c-.12.6-.22 1.29-.31 2z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ai'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M904.64 358.83a8.76 8.76 0 0 0-.39 1.45h-.62a10 10 0 0 1 .38-1.45z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aj'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M904.64 358.83H904a2.74 2.74 0 0 1 .31-.62h.69a2.1 2.1 0 0 0-.36.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ak'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905 358.69a5.62 5.62 0 0 0-.68 2h-.62a5.65 5.65 0 0 1 .67-2z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-al'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905 358.69h-.63a.56.56 0 0 1 .32-.23h.62a.54.54 0 0 0-.31.23z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-am'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905.31 358.46z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-an'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M904.68 358.9h.63c-.72 0-1.16 2.72-1.41 5.18h-.62c.25-2.46.72-5.18 1.4-5.18z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ao'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905 358.21h-.63a.5.5 0 0 1 .37-.23h.63a.47.47 0 0 0-.37.23z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ap'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905.31 358.9a.38.38 0 0 1 .27.13H905a.42.42 0 0 0-.28-.13z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aq'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M904.68 358.46h.63a.41.41 0 0 1 .29.14h-.6a.42.42 0 0 0-.32-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ar'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905.32 358a.45.45 0 0 1 .3.14H905a.45.45 0 0 0-.31-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-as'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905.32 357.76a.5.5 0 0 1 .31.14H905a.53.53 0 0 0-.32-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-at'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905.93 358.43h-.62a1.44 1.44 0 0 0-.3-.53h.62a1.44 1.44 0 0 1 .3.53z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-au'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905.83 358.43h-.63a.92.92 0 0 0-.2-.31h.62a.92.92 0 0 1 .21.31z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-av'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905 359h.62c.67.6 1.35 5.64 1.55 11.47h-.63c-.23-5.8-.91-10.84-1.54-11.47z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aw'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M905 358.6h.62c.71.63 1.42 5.84 1.61 11.88h-.62c-.21-6.04-.93-11.25-1.61-11.88z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ax'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M906 358.93h-.62a3.69 3.69 0 0 0-.2-.5h.63a3.81 3.81 0 0 1 .19.5z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-ay'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M906.13 359h-.63a6.5 6.5 0 0 0-.19-.61h.62a6.26 6.26 0 0 1 .2.61z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-az'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M906.13 359a23.51 23.51 0 0 1 .51 2.64H906a21.44 21.44 0 0 0-.51-2.64h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aA'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M906 358.93a18.8 18.8 0 0 1 .56 2.75H906a20.23 20.23 0 0 0-.56-2.75z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aB'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M906.54 366.27h-.09c-.12-1.54-.26-2.94-.43-4.14h.63c.16 1.2.31 2.6.42 4.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aC'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907 365.27h-.62c-.12-1.33-.25-2.54-.41-3.59h.63c.19 1.05.33 2.26.4 3.59z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aD'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907.2 367.35h-.63c0-.72-.09-1.42-.15-2.08h.58c.1.66.15 1.36.2 2.08z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aE'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907.07 366.27q.06.63.09 1.29h-.62l-.09-1.29z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aF'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907.2 367.35l.06 1.09h-.62c0-.37 0-.73-.07-1.09h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aG'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907.22 368.45h-.63c0-.3 0-.6-.05-.89h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aH'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907.25 369.21c0 .47 0 1 .06 1.43h-.62l-.06-1.43z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aI'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907.26 368.44q.06 1.06.09 2.19h-.62c0-.75-.06-1.48-.09-2.19h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-68ff652d2d-aJ'
        transform='translate(-49.16 -239.04)'
      >
        <path
          d='M907.22 368.45v.76h-.62v-.76h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <linearGradient
        id='s-68ff652d2d-aK'
        x1='-156.66'
        x2='-149.71'
        y1='376.39'
        y2='376.39'
        gradientTransform='translate(1054.45)'
        xlinkHref='#s-68ff652d2d-d'
      />
      <linearGradient
        id='s-68ff652d2d-aL'
        x1='-1220.49'
        x2='-1220.29'
        y1='375.05'
        y2='375.05'
        gradientTransform='matrix(-1 0 0 1 -317.87 0)'
        xlinkHref='#s-68ff652d2d-c'
      />
      <linearGradient
        id='s-68ff652d2d-aM'
        x1='-1222.42'
        x2='-1211.21'
        y1='376.34'
        y2='376.34'
        gradientTransform='matrix(-1 0 0 1 -317.87 0)'
        xlinkHref='#s-68ff652d2d-c'
      />
      <linearGradient
        id='s-68ff652d2d-aN'
        x1='-199.08'
        x2='-194.23'
        y1='418.96'
        y2='418.96'
        gradientTransform='rotate(-6.6 2.46 -9135.46)'
        xlinkHref='#s-68ff652d2d-e'
      />
      <linearGradient
        id='s-68ff652d2d-aO'
        x1='444.48'
        x2='445.48'
        y1='203.16'
        y2='203.16'
        xlinkHref='#s-68ff652d2d-f'
      />
      <linearGradient
        id='s-68ff652d2d-aP'
        x1='501.59'
        x2='502.59'
        y1='119.45'
        y2='119.45'
        xlinkHref='#s-68ff652d2d-f'
      />
      <linearGradient
        id='s-68ff652d2d-aQ'
        x1='438.59'
        x2='507.13'
        y1='162.46'
        y2='162.46'
        xlinkHref='#s-68ff652d2d-f'
      />
      <linearGradient
        id='s-68ff652d2d-aR'
        x1='437.84'
        x2='440.34'
        y1='213.41'
        y2='213.41'
        xlinkHref='#s-68ff652d2d-b'
      />
      <linearGradient
        id='s-68ff652d2d-aS'
        x1='505.38'
        x2='507.88'
        y1='113.89'
        y2='113.89'
        xlinkHref='#s-68ff652d2d-b'
      />
      <linearGradient
        id='s-68ff652d2d-g'
        x1='-1306.16'
        x2='-1306.16'
        y1='417.57'
        y2='438.02'
        gradientTransform='matrix(-1 0 0 1 -468.11 -239.04)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c1272d'
        />
        <stop
          offset='.53'
          stopColor='#c6594b'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-68ff652d2d-aT'
        x1='-1314.28'
        x2='-1297.58'
        y1='427.06'
        y2='427.06'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-aU'
        x1='878.32'
        x2='888.77'
        y1='408.02'
        y2='408.02'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-aV'
        x1='884.84'
        x2='895'
        y1='426.62'
        y2='426.62'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-aW'
        x1='878.16'
        x2='885.16'
        y1='417.77'
        y2='417.77'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-aX'
        x1='225.79'
        x2='225.79'
        y1='379.17'
        y2='393.89'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-aY'
        x1='209.6'
        x2='242.47'
        y1='385.95'
        y2='385.95'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-aZ'
        x1='231.33'
        x2='242.29'
        y1='368.95'
        y2='368.95'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-ba'
        x1='210.49'
        x2='221.45'
        y1='381.28'
        y2='381.28'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-bb'
        x1='220.58'
        x2='242.9'
        y1='375.73'
        y2='375.73'
        xlinkHref='#s-68ff652d2d-g'
      />
      <linearGradient
        id='s-68ff652d2d-bc'
        x1='221.52'
        x2='242.91'
        y1='376.12'
        y2='376.12'
        xlinkHref='#s-68ff652d2d-g'
      />
    </defs>
    <g
      id='surface'
    >
      <g
        id='mainSurface'
      >
        <path
          d='M917.52 286.62L1.6 212.38 196.4 96.11l668.6 37.7 52.52 152.81z'
          style={{
            fill: '#4d4d4d',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M893.98 273.52L35 207.58l172.52-102.97 642.2 36.13 44.26 132.78z'
          style={{
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M432.63 238.11l78.45-116.42'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <path
        className='tennisLines'
        d='M768.21 242.52l-604.83-44.37 105.51-79.22 496.91 29.81 2.41 93.78z'
      />
      <g
        id='surfaceBasket'
        className='basketballTwo'
      >
        <path
          d='M221.91 164.62l-104.28-6.06 38.95-23.24 96.37 6.1-31.04 23.2zM871.11 206.38l-127.34-8.61v-28.08l117.35 6.72 9.99 29.97z'
        />
      </g>
      <path
        id='surfaceBasketAcross'
        className='basketballOne'
        d='M533.28 153.94l-83.95-4.24 23.83-30.18 76.64 4.31-16.52 30.11z'
      />
      <path
        className='volleyballLines'
        d='M685.54 218.82l-433.09-30.91 62.33-53.92 379.57 23.7-8.81 61.13z'
      />
    </g>
    <g
      id='lines'
    >
      <g
        className='tennisLines'
      >
        <path
          d='M768.21 242.52l-604.83-44.37 105.51-79.22 496.91 29.81 2.41 93.78zM261.65 124.37l504.31 30.86M173.52 190.54l594.45 42.85M288.33 198.81l72.13-68.4M450.88 210.53l48.43-71.67M654.54 148.41l-18.79 75.44M330.66 158.49l316.44 20.97'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        className='volleyballLines'
      >
        <path
          d='M685.54 218.82l-433.09-30.91 62.76-54.29 379.25 23.31-8.92 61.89zM388.52 197.63l46.67-56.68M456.88 202.5l38.87-57.43M534.53 208.04l28.02-58.58'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        id='basketballLines'
        className='basketballTwo'
      >
        <ellipse
          cx='289.9'
          cy='392.11'
          rx='38.68'
          ry='11.48'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-4.71 -2640.76 870.42)'
        />
        <path
          d='M221.91 164.62l-104.28-6.06 38.95-23.24 96.37 6.1-31.04 23.2z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M243.65 351.73c40.9-2.84 117.63 16.39 83 41.12-58.5 41.76-175.34 37.94-208.43 33.76'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <ellipse
          cx='790.01'
          cy='422.55'
          rx='14'
          ry='40.9'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-86 635.096 328.639)'
        />
        <path
          d='M901.15 388.07c-104.71-6.73-153.29 12.22-152.81 31.93.62 25.47 59.25 55.94 184.87 64.31'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M871.11 206.38l-127.34-8.61v-28.08l117.35 6.72 9.99 29.97z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        id='basketballAcrossLines'
        className='basketballOne'
      >
        <path
          d='M446.22 354.44c-61.45 58.18 233.28 72.22 243.37 13.69'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M533.28 153.94l-83.95-4.24 23.83-30.18 76.64 4.31-16.52 30.11z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M582.45 393c-5.72 7.14-21.21 12.2-41.71 11.87-23.34-.38-45.91-5.87-42.27-16.39'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-49.16 -239.04)'
        />
      </g>
    </g>
    <image
      id='high'
      width='3695'
      height='1102'
      transform='translate(23.8) scale(.24)'
      xlinkHref={_32x151}
    />
    <image
      id='medium'
      width='3770'
      height='1105'
      transform='matrix(.24 0 0 .24 9.4 11.52)'
      xlinkHref={_32x152}
    />
    <image
      id='small'
      width='3763'
      height='1012'
      transform='matrix(.24 0 0 .24 10.12 28.08)'
      xlinkHref={_32x153}
    />
    <g
      id='wicket'
    >
      <path
        d='M230.05 98.4l-18.1-1.03V58.93l18.1 1.06V98.4z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M229.82 70.1l-.84-.07v-3.36l.84.06v3.37zM229.82 91.39l-.84-.06v-3.37l.84.07v3.36z'
        style={{
          fill: '#999',
        }}
      />
      <path
        d='M228.98 61.46v36.33'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-a)',
        }}
      />
      <path
        d='M227.79 61.39v36.36'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-h)',
        }}
      />
      <path
        d='M226.68 61.34v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-i)',
        }}
      />
      <path
        d='M225.57 61.22v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-j)',
        }}
      />
      <path
        d='M224.38 61.16v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-k)',
        }}
      />
      <path
        d='M223.27 61.09V97.5'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-l)',
        }}
      />
      <path
        d='M222.14 61.03v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-m)',
        }}
      />
      <path
        d='M220.95 60.95v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-n)',
        }}
      />
      <path
        d='M219.84 60.88v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-o)',
        }}
      />
      <path
        d='M218.73 60.82v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-p)',
        }}
      />
      <path
        d='M217.54 60.82v36.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-q)',
        }}
      />
      <path
        d='M216.43 60.67v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-r)',
        }}
      />
      <path
        d='M215.36 60.64v36.33'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-s)',
        }}
      />
      <path
        d='M214.17 60.58v36.39'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-t)',
        }}
      />
      <path
        d='M213.06 60.5v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-u)',
        }}
      />
      <path
        d='M228.98 67.06l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-v)',
        }}
      />
      <path
        d='M228.98 65.61l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-w)',
        }}
      />
      <path
        d='M228.98 64.23l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-x)',
        }}
      />
      <path
        d='M228.98 62.78l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-y)',
        }}
      />
      <path
        d='M228.98 61.4l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-z)',
        }}
      />
      <path
        d='M228.98 96.69l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-A)',
        }}
      />
      <path
        d='M228.98 97.89l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-B)',
        }}
      />
      <path
        d='M228.98 95.31l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-C)',
        }}
      />
      <path
        d='M228.98 93.86l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-D)',
        }}
      />
      <path
        d='M228.98 92.48l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-E)',
        }}
      />
      <path
        d='M228.98 91.03l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-F)',
        }}
      />
      <path
        d='M228.98 89.65l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-G)',
        }}
      />
      <path
        d='M228.98 88.2l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-H)',
        }}
      />
      <path
        d='M228.98 86.82l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-I)',
        }}
      />
      <path
        d='M228.98 85.37l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-J)',
        }}
      />
      <path
        d='M228.98 83.96l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-K)',
        }}
      />
      <path
        d='M228.98 82.51l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-L)',
        }}
      />
      <path
        d='M228.98 81.13l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-M)',
        }}
      />
      <path
        d='M228.98 79.68l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-N)',
        }}
      />
      <path
        d='M228.98 78.3l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-O)',
        }}
      />
      <path
        d='M228.98 76.85l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-P)',
        }}
      />
      <path
        d='M228.98 75.47l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-Q)',
        }}
      />
      <path
        d='M228.98 74.02l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-R)',
        }}
      />
      <path
        d='M228.98 72.64l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-S)',
        }}
      />
      <path
        d='M228.98 71.19l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-T)',
        }}
      />
      <path
        d='M228.98 69.81l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-U)',
        }}
      />
      <path
        d='M228.98 68.36l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-68ff652d2d-V)',
        }}
      />
      <path
        d='M211.95 97.17V58.99l18.1 1.04v38.19'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-68ff652d2d-W)',
        }}
      />
      <circle
        cx='214.86'
        cy='75.35'
        r='1.36'
        style={{
          fill: 'url(#s-68ff652d2d-X)',
        }}
      />
      <path
        d='M214.86 75.35l3.46.16'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-68ff652d2d-Y)',
        }}
      />
    </g>
    <g
      id='volleyballNet'
    >
      <path
        d='M500.39 139.92V99.63'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-68ff652d2d-b)',
        }}
      />
      <path
        d='M495.75 120.31l-38.16 51.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M495.75 109.78l-37.53 48.58M495.75 111.54l-37.53 48.55M495.75 113.17l-37.53 48.7M495.75 114.81l-37.53 48.81M495.81 116.31l-37.59 48.93M495.75 117.74l-37.53 49.22M495.67 119.09l-37.45 49.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150000005960464px',
        }}
      />
      <path
        d='M460.22 153.19v15.38M459.55 153.58v15.38M458.72 154.6v15.38M460.87 152.35v15.2M461.57 151.45v15.04M462.27 150.26v15.38M462.92 149.42v15.19M463.61 148.51v15.04M464.36 147.72v15.38M465.01 146.88v15.19M465.71 145.98v15.03M466.41 144.78v15.39M467.06 143.94v15.2M467.76 143.04v15.04M468.47 142.36v15.39M469.12 141.53v15.19M469.82 140.62v15.04M470.52 139.43v15.38M471.17 138.59v15.2M471.86 137.69v15.04M472.51 136.99v15.38M473.15 136.15v15.2M473.85 135.25v15.04M474.55 134.05v15.39M475.2 133.22v15.19M475.9 132.88v13.9M476.65 132.08v14.25M477.29 131.25v14.06M477.99 130.34v13.9M478.69 129.15v14.25M479.34 128.31v14.06M480.04 127.41v13.9M480.76 126.73v14.25M481.4 125.89v14.06M482.1 124.99v13.9M482.8 123.8v14.24M483.45 122.96v14.06M484.15 122.05v13.91M484.83 121.1v13.91M485.58 120.3v14.25M486.22 119.47v14.06M486.92 118.56v13.91M487.62 117.37v14.25M488.27 116.53v14.06M488.97 115.63v13.9M489.69 114.95v14.25M490.33 114.11v14.06M491.03 113.21v13.9M491.73 112.02v14.24M492.38 111.18v14.06M493.08 110.28v13.9M493.65 109.38v14.24M494.3 108.54v14.06M494.99 107.64v13.9'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150999993085861px',
        }}
      />
      <path
        d='M457.59 156.24l-7.87 9.28M457.72 171.23l-9.43 14.44M457.59 166.05l-7.87 10.82M495.75 107.2l4.76-6.3M495.81 116.31l4.63-5.66M495.81 120.12l4.58-4.97'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
        }}
      />
      <path
        d='M495.75 120.31V107.2l-38.16 49.04v15.27'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-68ff652d2d-f)',
        }}
      />
      <path
        d='M449.72 212.84v-50.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-68ff652d2d-Z)',
        }}
      />
    </g>
    <g
      id='basketballAcross'
      className='basketballOne'
    >
      <path
        d='M510 122.36l-2.45-.15V69.84l2.45-.01v52.53z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M510 122.36l1.22-.69V69.43l-1.22.4v52.53z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M511.22 69.43l-1.22.4h-3.12l2.17-.48 2.17.08z'
        style={{
          fill: '#858589',
        }}
      />
      <path
        d='M509.69 88.89l-2.14-.17-3.75-16.62 2.13.17 3.76 16.62z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M509.69 83.48v5.41l-3.75-16.62h-2.36l1.13-1.17h2.18l2.8 12.38z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M569.33 301.47c-1.64-5.56-7.54-9.68-14.59-9.68s-12.21 2.5-13.84 8.06v7.09l6.85 7.22L562 315l7.35-6.41v-.09z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M562 315.09l-14.27-.83-6.9-7.26v-7.12c1.57-5.33 6.39-8.14 13.94-8.14 7 0 13 4 14.68 9.75v7.2zm-14.18-1l14.11.82 7.29-6.36v-7c-1.68-5.65-7.63-9.59-14.49-9.59-7.45 0-12.2 2.76-13.74 8v7z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M561.3 314.38l-13.3-.78-6.46-6.83v-6.72c1.47-5 6-7.64 13-7.64 6.49 0 12.13 3.75 13.71 9.12v6.79l-.09.14zm-13-1.36l12.82.75 6.59-5.68v-6.43c-1.53-5.1-6.92-8.66-13.13-8.66-4.71 0-10.69 1.25-12.45 7.18v6.39z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M506.5 74.98l-2.89-.17v-2.72l2.89.15v2.74z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M559.77 311.8l-10.7-.6v-8.85l10.7.58zm-10-1.28l9.26.52v-7.42l-9.26-.51z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M554.54 312.21a3.38 3.38 0 0 0-1.35-.29 5 5 0 0 0-1.59.09l1.17-.88 2.89.15z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M553.82 313.51l-6.76.28a.15.15 0 0 1-.18-.1.15.15 0 0 1 .09-.19l6.76-.27a.15.15 0 0 1 .18.1.14.14 0 0 1-.09.18z'
        style={{
          fill: 'url(#s-68ff652d2d-aa)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M556.92 314.09a.25.25 0 0 1 0 .17.11.11 0 0 1-.19 0l-2.41-.74a.25.25 0 0 1 0-.28.11.11 0 0 1 .19 0l2.41.74a.24.24 0 0 1 0 .11z'
        style={{
          fill: 'url(#s-68ff652d2d-ab)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M547.49 316.21a8.02 8.02 0 0 1-.17-.74l-.2-.14c.11.3.24.59.37.88zM548.3 316.44c.14.29.29.58.45.86a5.78 5.78 0 0 1-.47-1.36l-.18-.07zM553.37 318.85c.21-.22.42-.45.61-.69-.05-.41-.13-.82-.22-1.22a.56.56 0 0 1 0-.12q-.35.49-.72 1c.08.24.16.48.25.71zM549.29 314.77c.09.36.18.72.28 1.08l.68.1c0-.78.06-1.55.11-2.33a3.53 3.53 0 0 1 .16-1.23 8.81 8.81 0 0 0-1.89.43 4.36 4.36 0 0 1 .66 1.95zM548.84 317.24a6.94 6.94 0 0 0 1 1.36c0-.12.08-.24.11-.36s.07-.29.1-.43a12 12 0 0 1-.39-1.15 4 4 0 0 1-.29-.43 7.86 7.86 0 0 1-.93-.25 5.54 5.54 0 0 0 .4 1.26zM553.83 316.62a8.53 8.53 0 0 1 .29 1.37v-.07c.08-.6.12-1.2.15-1.8h-.2zM551.46 315c0-.34-.08-.68-.12-1a5.9 5.9 0 0 0-.2-1.2c0-.1-.13-.3-.22-.32s-.26.21-.31.37a5.26 5.26 0 0 0-.09 1.05c0 .64 0 1.34-.09 2.06h1.12q-.03-.44-.09-.96zM551.74 316.44a2.11 2.11 0 0 1 0 .26l.11-.27h-.13zM554.37 317.64c.17-.25.33-.5.47-.75a7.3 7.3 0 0 0 .06-.94l-.41.12c-.02.52-.06 1.05-.12 1.57zM553.75 316.39l.11-.18h-.14c.02.08.02.13.03.18zM551.6 317v-.55h-.37c.11.16.24.35.37.55zM549.77 316.57c.13.15.25.32.37.48 0-.23.05-.46.07-.68l-.52-.08c.03.1.05.19.08.28zM550.32 317.29c.12.17.24.33.37.49l.33.45c.15-.28.28-.56.42-.84l.07-.15c-.16-.27-.3-.54-.44-.81l-.66-.05c-.02.31-.05.62-.09.91zM551.77 317.07a1.55 1.55 0 0 1 0 .22c.21.34.39.69.58 1l.48-.62c-.15-.42-.3-.86-.42-1.29h-.37c-.04.26-.17.48-.27.69zM555.06 316.28c.05-.14.1-.29.14-.44l-.14.05a2.54 2.54 0 0 1 0 .39zM552.94 317.57c.24-.33.48-.66.71-1a2.46 2.46 0 0 1-.07-.29c-.34.06-.7.1-1.07.13.15.38.29.77.43 1.16zM553.68 315.83l.5-.11c.12-.21.25-.44.36-.66a15.36 15.36 0 0 1 1-2.14 7.06 7.06 0 0 0-2-.53v.27c.15 1.05.03 2.12.14 3.17zM556.64 314c0-.34-.31-.69-.84-1a8.9 8.9 0 0 1-.27 2.2c.72-.31 1.12-.74 1.11-1.2zM547.8 316.82a13.12 13.12 0 0 0 .69 1.13v.12c.26.38.53.75.81 1.12l.11.14c.06-.13.12-.26.17-.39a9.81 9.81 0 0 1-1.11-1.61 8.85 8.85 0 0 1-.64-1.53l-.37-.18c.14.38.23.79.34 1.2zM547.44 315.05l.3.19c-.14-.45-.27-.91-.38-1.37a7.71 7.71 0 0 0 .08 1.18z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M551.71 316h.29q.13-.37.24-.75c.17-.65.27-1.31.46-1.95a4.46 4.46 0 0 1 .35-1 11.64 11.64 0 0 0-1.34 0h-.66a4.39 4.39 0 0 1 .46 1.88c.11.63.16 1.23.2 1.82zM553.44 313.43a3.55 3.55 0 0 0-.05-.86c-.1-.39-.17-.05-.25.12a4.09 4.09 0 0 0-.18.49c-.19.57-.3 1.17-.44 1.76a9.88 9.88 0 0 1-.31 1.06 12.33 12.33 0 0 0 1.3-.14c-.1-.8-.05-1.61-.07-2.43zM548.19 315.46a9.36 9.36 0 0 1 0-2.48 3.4 3.4 0 0 0-.81.48c.15.63.32 1.26.52 1.88zM554.65 318.38c.18-.35.33-.7.48-1.06a12.41 12.41 0 0 0 .38-1.6h-.11a5.43 5.43 0 0 1-.4 1.09 10 10 0 0 1-.35 1.57z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M500.33 77.22z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M555.4 317c0 .17-.1.34-.15.51a9.7 9.7 0 0 0 1-2.18 4.19 4.19 0 0 1-.47.29 11.1 11.1 0 0 1-.38 1.38zM555.66 313a7.35 7.35 0 0 0-.51 1.19 11.5 11.5 0 0 1-.66 1.37.75.75 0 0 1-.07.12 7.28 7.28 0 0 0 .94-.33 9 9 0 0 0 .3-2.35zM551.24 319.65l.34-.4-.54-.74-.25.48c.14.22.29.45.45.66zM554.34 317.94c0 .3-.09.6-.14.89.07-.07.15-.14.22-.22.13-.43.25-.87.34-1.32a7.22 7.22 0 0 1-.42.65zM553.43 319c.06.15.11.3.16.46.13-.15.27-.29.4-.43v-.14-.52q-.26.34-.56.63zM548.24 314.29a8.24 8.24 0 0 0 .07 1.22 6.85 6.85 0 0 0 1.07.3c-.16-.62-.3-1.24-.45-1.86 0-.15-.19-.94-.42-1.09l-.19.08a5.1 5.1 0 0 0-.06.8c-.01.19-.02.37-.02.55zM551.79 317.7v1.31l.46-.56c-.15-.25-.25-.45-.46-.75zM550.94 318.38l-.39-.52-.27-.33c0 .12 0 .23-.06.35a7.16 7.16 0 0 0 .48 1zM547.24 313.61a.81.81 0 0 0 0 1.28 9.13 9.13 0 0 1 0-1.28zM551.61 317.41q-.23.46-.48.93l.49.66c.01-.52.01-1.06-.01-1.59zM552.9 319.34l.37-.37-.15-.44-.21-.62-.46.59.12.23zM550.11 317.3l-.19-.22.15.42a1.42 1.42 0 0 0 .04-.2zM550.6 319c-.05-.08-.1-.16-.14-.24s-.21-.41-.3-.62a4.44 4.44 0 0 1-.19.62l.48.5zM549.75 318.75q-.27-.33-.51-.66c.15.23.32.46.5.69z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M548.19 315.46l.12.05a8.24 8.24 0 0 1-.07-1.22v-.55a5.1 5.1 0 0 1 .06-.8h-.1a9.36 9.36 0 0 0-.01 2.52zM550.25 316h.18c0-.72.05-1.42.09-2.06a5.26 5.26 0 0 1 .09-1.05c0-.16.11-.42.31-.37s.19.22.22.32a5.9 5.9 0 0 1 .2 1.2c0 .34.09.68.12 1s.07.66.09 1h.16c0-.61-.09-1.21-.17-1.81a4.39 4.39 0 0 0-.46-1.88l-.56.06a3.53 3.53 0 0 0-.16 1.23c-.05.76-.07 1.53-.11 2.36zM547.44 315.05a7.71 7.71 0 0 1-.08-1.18c.11.46.24.92.38 1.37l.19.1c-.2-.62-.37-1.25-.52-1.88l-.17.15a9.13 9.13 0 0 0 0 1.28zM548.31 312.49a.17.17 0 0 0-.13.05l.14-.05zM548.93 314c.15.62.29 1.24.45 1.86h.19c-.1-.36-.19-.72-.28-1.08a4.36 4.36 0 0 0-.66-1.95h-.12c.23.17.38.97.42 1.17z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M555.25 317.46c0-.17.11-.34.15-.51a11.1 11.1 0 0 0 .4-1.36l-.31.15a12.41 12.41 0 0 1-.38 1.6c-.15.36-.3.71-.48 1.06a10 10 0 0 0 .35-1.53 5.43 5.43 0 0 0 .4-1.09l-.2.08c0 .15-.09.3-.14.44a2.54 2.54 0 0 0 0-.39l-.16.06a7.3 7.3 0 0 1-.06.94c-.14.25-.3.5-.47.75.06-.52.1-1.05.12-1.57l-.17.05c0 .6-.07 1.2-.15 1.8v.07a8.53 8.53 0 0 0-.29-1.37l.29-.46-.25.06-.11.18v-.15h-.15a2.46 2.46 0 0 0 .07.29c-.23.35-.47.68-.71 1-.14-.39-.28-.78-.43-1.17h-.09c.12.43.27.87.42 1.29l-.48.62c-.19-.34-.37-.69-.58-1a1.55 1.55 0 0 0 0-.22c.1-.21.19-.43.28-.64h-.18l-.11.27a2.11 2.11 0 0 0 0-.26h-.17v.55c-.13-.19-.26-.38-.4-.56h-.13c.14.27.28.54.44.81l-.07.15c-.14.28-.27.56-.42.84l-.33-.45c-.13-.16-.25-.32-.37-.49 0-.3.07-.6.09-.91h-.2c0 .22 0 .45-.07.68-.12-.16-.24-.33-.37-.48s0-.18-.08-.28h-.36a4 4 0 0 0 .29.43 12 12 0 0 0 .39 1.15c0 .14-.06.29-.1.43s-.07.24-.11.36a6.94 6.94 0 0 1-1-1.36 5.54 5.54 0 0 1-.44-1.26h-.12a5.78 5.78 0 0 0 .47 1.36c-.16-.28-.31-.57-.45-.86l-.2-.57-.21-.09a8.85 8.85 0 0 0 .64 1.53 9.81 9.81 0 0 0 1.11 1.61c0 .13-.11.26-.17.39l-.11-.14c-.28-.37-.55-.74-.81-1.12v-.12a13.12 13.12 0 0 1-.69-1.13c-.11-.41-.2-.82-.28-1.22l-.2-.13c0 .26.1.5.17.74-.13-.29-.26-.58-.37-.88l-.17-.15a11.26 11.26 0 0 0 1.62 3.16c.12.43.25.84.4 1.25a5.3 5.3 0 0 0 0 .69 11.94 11.94 0 0 1-.1 1.79v.41c-.09.46-.34 1.82.31 1.35l.05-.05a.68.68 0 0 0 .35.28.55.55 0 0 0 .57-.18c.15.26.35.52.63.5a.54.54 0 0 0 .4-.29l.1-.15a.71.71 0 0 0 1 .18 1.32 1.32 0 0 0 .31-.35.67.67 0 0 0 .2.21c.38.28.56-.16.63-.47v-.11l.2.37c0 .07.13 0 .15 0a7.8 7.8 0 0 0 .09-2 7.43 7.43 0 0 1 .1-1 .06.06 0 0 0 0-.07c.06-.31.14-.63.22-.94l.09-.14a12.56 12.56 0 0 0 .6-1.29.09.09 0 0 0 0-.06.61.61 0 0 1 0-.12 12.54 12.54 0 0 0 1.53-3.09l-.24.19a9.7 9.7 0 0 1-.99 2.11zm-1.53-.67a.56.56 0 0 0 0 .12c.09.4.17.81.22 1.22-.19.24-.4.47-.61.69l-.12-.36c-.09-.23-.17-.47-.25-.71q.42-.47.76-.96zm-4.53 3.37l.24.56c-.07.09-.15.17-.23.26 0-.24-.07-.48-.1-.72zm-.1 0v-.32l.09.21zm.41.72c.08.17.16.34.25.51l-.36.43c-.06-.22-.11-.45-.16-.69a2.16 2.16 0 0 0 .27-.25zm1.81-.47l-.23-.21zm-.11-.36l.08-.09.44.51-.09.08zm.24.68l-.47.46-.36-.44.38-.44zm-.4-.85l-.48-.49a2.53 2.53 0 0 0 .13-.22 6.25 6.25 0 0 0 .44.61zm-.11.13l-.1-.08-.36-.36zm-.12.14l-.35.4-.35-.42.26-.4zm-.45.52c-.17.19-.34.39-.5.59a5.69 5.69 0 0 1-.24-.5c.14-.16.28-.33.41-.51zm-.5.93c.08.17.17.34.26.5a1 1 0 0 1-.13.16l-.31.42c-.08-.21-.16-.43-.22-.64zm.18 0l-.07-.13.54-.62c.12.15.24.29.35.44-.21.22-.42.44-.62.67-.07-.11-.14-.23-.24-.35zm.92-.18l.44.57-.27.32-.4.5c-.14-.23-.27-.46-.4-.69.2-.23.41-.46.67-.69zm.11-.1l.3-.3.19-.19c.15.14.29.29.43.44l-.5.6zm1.71-.61l.4-.45.24.49c-.11.15-.22.31-.34.46-.08-.16-.2-.33-.3-.49zm.15.7l-.11.14c-.12-.16-.25-.31-.38-.46.07-.07.13-.15.19-.22q.17.28.3.55zm-.28-.91l-.29-.43.5-.48.21.44zm-.14.16l-.22.26c-.13-.14-.25-.27-.36-.41l.31-.3zm-.31.36l-.11.13-.07-.07a4.27 4.27 0 0 0-.29-.41l.09-.09c.18.16.26.3.38.42zm-.06.41a5.19 5.19 0 0 1 .36.46l-.12.14-.42.5a1 1 0 0 1-.08-.11l-.28-.4zm.26.06a1.29 1.29 0 0 0-.16-.17l.11-.13c.13.15.26.31.38.47a1.47 1.47 0 0 0-.1.13zm.43.29l.28.41c0 .07-.05.13-.07.2-.1-.16-.21-.32-.32-.48zm.08-.11l.1-.12.2.37a.56.56 0 0 1 0 .12c-.12-.12-.21-.24-.3-.36zm.26-.32l.33-.44v.07l-.21.65zm.14-1.23c.08-.09.17-.18.25-.28.05.15.1.3.16.45l-.19.29c-.07-.14-.15-.29-.22-.45zm-.12-.23l-.21-.42.34-.35.15.46zm-.28-2l.21.62.15.44-.37.37-.33-.61-.12-.23zm-.51.81c.13.24.26.49.38.74l-.51.49-.36-.52-.09-.13.53-.67a.41.41 0 0 0 .05.11zm-.61-1c.16.25.31.5.46.75l-.46.56c.01-.44.01-.88 0-1.31zm0 1.82c.13.18.25.37.37.55l-.19.18-.14.13-.43-.54.33-.41zm-.64-1.18q.25-.46.48-.93v1.61l-.49-.66zm-.09.17l.54.74-.34.4c-.16-.21-.31-.44-.45-.66zm-.76-1l.27.33.39.52-.24.46a7.16 7.16 0 0 1-.48-1c0-.06.03-.17.04-.29zm-.36-.45l.19.22a1.42 1.42 0 0 1 0 .2zm.24 1.08c.09.21.19.42.3.62s.09.16.14.24l-.15.26-.48-.5a4.44 4.44 0 0 0 .17-.6zm-.24.78l.44.48v.05c-.15-.16-.29-.33-.43-.49zm-.68-.85q.24.33.51.66c-.21-.18-.38-.41-.53-.64zm.59 1.06a6 6 0 0 0 .42.46l-.27.41-.36-.45c.07-.15.13-.27.19-.4zm-.27.51l.35.45c-.12.17-.24.33-.37.48l-.24-.56c.07-.1.16-.22.24-.35zm-.79-1q.32.44.66.87c-.06.13-.13.25-.19.38-.18-.43-.34-.84-.49-1.26zm.32 2.66q.07.34.18.69l-.27.35c-.02-.34.05-.7.07-1.05zm-.22 1.73a1.64 1.64 0 0 0 .1.38c-.21-.14-.15-.18-.12-.41zm.32.45a1.81 1.81 0 0 1-.17-.59v-.36c0-.12.23-.23.34-.35.07.22.16.44.25.65l-.29.46c-.1.09-.12.16-.15.18zm.12.15c.06-.11.11-.24.17-.33l.18-.29a3.58 3.58 0 0 0 .24.48 1.71 1.71 0 0 0 .12.23c-.19.15-.4.2-.73-.1zm.63-.37l-.18-.39a4.29 4.29 0 0 1 .36-.48l.09-.12c.13.23.26.48.4.72-.11.13-.22.26-.32.4s-.1.14-.16.2zm.75.69c-.34 0-.36 0-.46-.19l.07-.1.4-.5a7.06 7.06 0 0 0 .42.64c-.14.2-.14.2-.45.14zm.51-.31c-.1-.16-.18-.33-.25-.45l-.12-.19.69-.83.1.14c.09.12.18.25.26.38-.16.2-.33.41-.48.63zm1.27 0a.74.74 0 0 1-.94.34.71.71 0 0 1-.2-.19 6.77 6.77 0 0 1 .48-.75l.18-.23c.11.15.21.31.31.47s.12.22.18.34zm.09-.17a6.36 6.36 0 0 1-.49-.77c.19-.22.37-.45.55-.67.12.17.23.35.34.53-.1.25-.21.5-.32.75-.05.07-.07.13-.1.18zm.77-.16c0 .12-.05.25-.08.38-.28.13-.47.12-.58 0a6.14 6.14 0 0 0 .39-.93c.1.16.19.33.28.5a.25.25 0 0 1-.03.07zm0-.35c-.08-.15-.16-.29-.25-.43a.87.87 0 0 0 .07-.17c.07.12.13.24.19.37a2.29 2.29 0 0 1 .02.27zm0-.5l-.15-.28a.36.36 0 0 1 0-.09l.12.24a.57.57 0 0 1 .1.15zm0-.66c0-.06.05-.13.07-.2v.3zm.28 1.72l-.2-.36v-.18a3.26 3.26 0 0 1 .15.44.13.13 0 0 0 .11.12zm0-.32a3.94 3.94 0 0 0-.18-.48v-.15l.19.36c.1.07.1.2.09.29zm0-1.68v1.06a3.52 3.52 0 0 0-.16-.39c0-.31 0-.62.08-.92 0 0 .05.11.08.16a.28.28 0 0 1 .11.11zm0-.38l-.06-.14c0-.14.06-.28.1-.42a.36.36 0 0 1 0 .09c.16.17.13.33.11.49zm0-1.13c0-.1-.06-.21-.1-.31l.23-.25c.11.21.07.39.02.55zm.13.39v-.13c.18.05.16.1.15.15zm.24-1.4c-.13.14-.27.28-.4.43-.05-.16-.1-.31-.16-.46q.3-.3.57-.63v.52zm.27.09v.07l-.06.11v-.13l.11-.12zm-.06-.3c0-.29.1-.59.14-.89a7.22 7.22 0 0 0 .42-.65c-.09.45-.21.89-.34 1.32-.08.12-.16.19-.23.26z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M552.27 315.26q-.1.38-.24.75h.18a9.88 9.88 0 0 0 .31-1.06c.14-.59.25-1.19.44-1.76a4.09 4.09 0 0 1 .18-.49c.08-.17.15-.51.25-.12a3.55 3.55 0 0 1 .05.86c0 .82 0 1.63.07 2.43h.17c-.11-1.05 0-2.12-.1-3.17v-.27l-.47-.05a4.46 4.46 0 0 0-.35 1c-.22.62-.32 1.23-.49 1.88zM554.18 315.72l.24-.06a.75.75 0 0 0 .07-.12 11.5 11.5 0 0 0 .66-1.37 7.35 7.35 0 0 1 .51-1.19 9 9 0 0 1-.3 2.35l.17-.08a8.9 8.9 0 0 0 .27-2.2l-.27-.13a15.36 15.36 0 0 0-1 2.14c-.1.22-.23.45-.35.66z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M555.8 312.93a.17.17 0 0 0 .13-.17.18.18 0 0 0-.18-.17.19.19 0 0 0-.18.18.19.19 0 0 0 0 .07l-.06.08.27.13a.48.48 0 0 0 .02-.12zM551 312.21a.13.13 0 0 0 0-.06.21.21 0 0 0-.21-.2.22.22 0 0 0-.2.21v.08a.64.64 0 0 0-.1.13l.6-.06a.41.41 0 0 0-.09-.1zM553.72 312.22a.15.15 0 0 0 0-.16.2.2 0 0 0-.24-.11.2.2 0 0 0-.13.14.2.2 0 0 0 0 .11.58.58 0 0 0-.1.12l.52.06a.76.76 0 0 0-.05-.16zM548.24 312.82a1 1 0 0 1 0 .16h.1v-.09a.14.14 0 0 1 .14 0h.12a1.06 1.06 0 0 0-.15-.15.16.16 0 0 0-.16-.18l-.14.05a.18.18 0 0 0 .09.21zM547.41 313.46v-.06a.16.16 0 0 0 0-.09.17.17 0 0 0-.18-.16.17.17 0 0 0-.16.17.17.17 0 0 0 .16.16.57.57 0 0 0 0 .13z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M548.37 312.85v.09l.19-.08a.14.14 0 0 0-.19-.01z'
        style={{
          fill: 'url(#s-68ff652d2d-c)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M551.73 311.88a10 10 0 0 0-3.41.61.16.16 0 0 1 .16.18 1.06 1.06 0 0 1 .15.15 8.81 8.81 0 0 1 1.89-.43.27.27 0 0 1 .09-.12.24.24 0 0 1 0-.08.18.18 0 0 1 .18-.19.19.19 0 0 1 .19.18.07.07 0 0 1 0 .05.41.41 0 0 1 .13.1h.66a11.64 11.64 0 0 1 1.34 0 .44.44 0 0 1 .08-.11.17.17 0 0 1 0-.1c0-.06.06-.11.12-.13a.18.18 0 0 1 .22.1.19.19 0 0 1 0 .15.58.58 0 0 1 0 .14 7.06 7.06 0 0 1 2 .53l.06-.08a.19.19 0 0 1 0-.07.19.19 0 0 1 .18-.18.18.18 0 0 1 .18.17.17.17 0 0 1-.13.17.48.48 0 0 1 0 .12c.53.3.84.65.84 1s-.39.85-1.11 1.21l-.17.08a7.28 7.28 0 0 1-.94.33l-.24.06-.5.11h-.17a12.33 12.33 0 0 1-1.3.14H550.27l-.68-.1h-.19a6.85 6.85 0 0 1-1.07-.3l-.12-.05-.26-.12-.19-.1-.3-.19-.19-.16a.81.81 0 0 1 0-1.28.57.57 0 0 1 0-.13.17.17 0 0 1-.16-.16.17.17 0 0 1 .16-.17.17.17 0 0 1 .18.16.16.16 0 0 1 0 .09v.06a3.4 3.4 0 0 1 .81-.48 1 1 0 0 0 0-.16.18.18 0 0 1-.06-.28c-1 .44-1.7 1.06-1.68 1.74a1.32 1.32 0 0 0 .45.9l.17.15.2.14.2.13.37.18.21.09.18.07h.12a7.86 7.86 0 0 0 .93.25h.36l.52.08h.2l.66.05H552.55c.37 0 .73-.07 1.07-.13H553.91l.25-.06h.2l.17-.05.41-.12.16-.06.14-.05.2-.08h.11l.31-.15a4.19 4.19 0 0 0 .47-.29l.24-.19a1.41 1.41 0 0 0 .54-1.06c-.11-1.38-2.42-2.33-5.38-2.26z'
        style={{
          fill: 'url(#s-68ff652d2d-ac)',
        }}
        transform='translate(-49.16 -239.04)'
      />
    </g>
    <g
      id='basketball'
      className='basketballTwo'
    >
      <path
        d='M142.58 98.64h-2.04l1.41-1.4h1.74l-1.11 1.4z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M142.58 144.35l1.11-.68V97.24l-1.11 1.4v45.71z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M142.58 144.35l-2.04-.12V98.64h2.04v45.71z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M142.58 106.44l1.11-.61 7.43-12.24h-.85l-7.69 12.85z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M142.58 103.79v2.65l7.68-12.85h.86v-2.01l-1.26.16-7.28 12.05z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M199.1 316.67c-3.34.61-6.41 5.66-7.27 10.91l.39 5.86 2.44 5.84 11.34-6.53 1.07-6.59v-4.61c-1.62-3.3-4.24-5.55-7.97-4.88z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M194.62 339.42l-2.5-6-.39-5.86c.91-5.6 4.14-10.42 7.35-11 4.28-.78 6.77 2.25 8.1 4.93v4.65l-1.07 6.65zm-2.31-6l2.4 5.73 11.23-6.46 1.06-6.54v-4.58c-1.3-2.61-3.73-5.56-7.88-4.8-3.14.57-6.3 5.33-7.2 10.83z'
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M195.05 338.54l-2.36-5.66-.36-5.42c.85-5.23 3.87-9.73 6.88-10.28 4-.74 6.35 2.1 7.6 4.61v4.35l-1 6.21h-.08zm-2-5.71l2.16 5.17 10.25-5.89 1-6v-4.19c-1.2-2.38-3.4-5.06-7.17-4.37-2.86.53-5.75 4.89-6.57 9.93z'
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M196.06 335.28v-7.5l8.16-4.68v7.45zm.79-7.07v5.73l6.58-3.82v-5.69z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M150.32 96.11l2.28-1.3-.01-2.04-2.27 1.27v2.07z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M201.24 333.79a2.62 2.62 0 0 1 .85-.67 4 4 0 0 1 1.16-.5l-1.49-.81-2 1.11z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M201.24 334.23l6-1.64a.13.13 0 0 0 .11-.16.13.13 0 0 0-.16-.1l-6 1.64a.12.12 0 0 0-.11.15.14.14 0 0 0 .16.11z'
        style={{
          fill: 'url(#s-68ff652d2d-d)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M202 335.39a.12.12 0 0 0 .11 0 .11.11 0 0 0 0-.18l-1.19-1.05a.12.12 0 0 0-.19 0 .13.13 0 0 0 0 .18l1.19 1.06a.11.11 0 0 0 .08-.01z'
        style={{
          fill: 'url(#s-68ff652d2d-e)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M202 336a4.74 4.74 0 0 1-.16-.65l-.19-.12c.14.29.25.55.35.77zM202.77 336.23c.13.26.26.51.41.75a4.75 4.75 0 0 1-.44-1.19l-.15-.06zM207.42 338.35c.2-.2.38-.4.56-.61a9.78 9.78 0 0 0-.2-1.08.42.42 0 0 1 0-.1q-.31.43-.66.87l.23.63c0 .08.03.19.07.29zM203.68 334.77c.08.31.16.63.25.94a5.77 5.77 0 0 0 .62.09c0-.68.06-1.36.11-2a3.17 3.17 0 0 1 .14-1.09 8.25 8.25 0 0 0-1.73.38 3.92 3.92 0 0 1 .61 1.68zM203.26 336.94a6.06 6.06 0 0 0 .89 1.19c0-.11.07-.21.1-.32l.09-.38c-.14-.32-.26-.66-.37-1-.09-.13-.18-.25-.26-.38a8.74 8.74 0 0 1-.85-.22 4.91 4.91 0 0 0 .4 1.11zM207.84 336.39a6.73 6.73 0 0 1 .26 1.2l.05-.06c.07-.53.12-1 .14-1.58h-.19zM205.67 335c0-.3-.07-.6-.12-.9a5.23 5.23 0 0 0-.17-1c0-.09-.12-.26-.21-.28s-.24.19-.28.33a4.7 4.7 0 0 0-.09.92c0 .56 0 1.18-.08 1.81h1c.01-.31-.02-.6-.05-.88zM205.92 336.23a1.79 1.79 0 0 1 0 .23c0-.08.07-.16.1-.23h-.12zM208.34 337.28a4.59 4.59 0 0 0 .42-.66 4.47 4.47 0 0 0 .07-.82l-.38.11c-.02.46-.05.92-.11 1.37zM207.77 336.19l.11-.16h-.13s.01.12.02.16zM205.8 336.72v-.49h-.34c.1.15.22.32.34.49zM204.11 336.34c.12.14.24.28.35.43l.06-.6-.48-.07a2.17 2.17 0 0 1 .07.24zM204.62 337c.11.14.22.29.34.43l.31.39.38-.73a.91.91 0 0 1 .07-.14 7.24 7.24 0 0 1-.41-.71h-.61c-.02.21-.04.48-.08.76zM206 336.78a1.28 1.28 0 0 1 0 .19c.19.3.36.61.53.91l.44-.54c-.14-.37-.27-.75-.38-1.14h-.35a5.62 5.62 0 0 1-.24.58zM209 336.09c.05-.12.09-.25.13-.38H209a1.93 1.93 0 0 1 0 .38z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M207 337.23c.23-.29.45-.59.66-.89a2.5 2.5 0 0 1-.07-.26c-.31.05-.64.09-1 .12.18.33.31.68.41 1.03zM207.7 335.69a3.4 3.4 0 0 0 .46-.09c.12-.19.23-.38.34-.58a13 13 0 0 1 .9-1.88 6.51 6.51 0 0 0-1.82-.46 1 1 0 0 1 0 .23c.13.93.03 1.87.12 2.78zM210.42 334.13c0-.31-.28-.61-.77-.87a7.22 7.22 0 0 1-.25 1.92c.66-.31 1.03-.69 1.02-1.05zM202.31 336.57a10.33 10.33 0 0 0 .63 1h.05v.1c.24.34.49.66.75 1a1.13 1.13 0 0 0 .1.13l.15-.34a9.45 9.45 0 0 1-1-1.42 6.92 6.92 0 0 1-.59-1.34l-.34-.16c.06.31.15.66.25 1.03zM202 335l.27.17c-.13-.4-.25-.8-.34-1.21A5.93 5.93 0 0 0 202 335zM205.9 335.86h.29c.08-.22.16-.43.22-.66.15-.57.25-1.15.43-1.71a3.74 3.74 0 0 1 .31-.85 12 12 0 0 0-1.23 0h-.61c.35.36.4 1.46.43 1.65.07.51.12 1.04.16 1.57zM207.49 333.59a3.24 3.24 0 0 0-.05-.76c-.1-.34-.16-.05-.23.11s-.12.28-.17.42c-.18.51-.27 1-.4 1.56a7.54 7.54 0 0 1-.29.92 10.59 10.59 0 0 0 1.2-.12 16.74 16.74 0 0 1-.06-2.13zM202.67 335.37a7.24 7.24 0 0 1 0-2.18 3.23 3.23 0 0 0-.75.42 16.49 16.49 0 0 0 .48 1.66zM208.6 337.94c.16-.31.3-.62.43-.94a9.71 9.71 0 0 0 .36-1.41h-.1a5.79 5.79 0 0 1-.37 1 10.58 10.58 0 0 1-.32 1.35z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M154.7 97.03z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M209.29 336.68l-.15.45a8.41 8.41 0 0 0 1-1.92 3.48 3.48 0 0 1-.43.25 10.77 10.77 0 0 1-.42 1.22zM209.53 333.19a5.85 5.85 0 0 0-.48 1.05 11.19 11.19 0 0 1-.6 1.2.61.61 0 0 1-.07.1 7.43 7.43 0 0 0 .87-.28 8.13 8.13 0 0 0 .28-2.07zM205.46 339.05c.11-.11.21-.23.32-.35l-.5-.65-.23.42c.13.2.27.39.41.58zM208.31 337.55c0 .26-.08.53-.13.78a1.8 1.8 0 0 0 .2-.19 11.72 11.72 0 0 0 .32-1.16 5.72 5.72 0 0 1-.39.57zM207.48 338.49c.05.14.09.27.14.4l.37-.37v-.13-.46c-.16.19-.33.38-.51.56zM202.71 334.34a7.59 7.59 0 0 0 .07 1.07 5.76 5.76 0 0 0 1 .27c-.15-.54-.28-1.09-.41-1.63 0-.14-.18-.84-.39-1l-.17.06a4 4 0 0 0-.06.71c-.03.18-.04.36-.04.52zM206 337.33v1.16l.42-.49zM205.19 337.94l-.36-.46-.24-.29-.06.31a6.71 6.71 0 0 0 .44.84zM201.79 333.75a.68.68 0 0 0 0 1.12 8.4 8.4 0 0 1 0-1.12zM205.81 337.08c-.14.28-.29.55-.44.82l.45.58c0-.48 0-.93-.01-1.4zM207 338.78l.33-.33c0-.13-.08-.25-.13-.38s-.13-.37-.2-.55l-.41.52a2 2 0 0 0 .11.2zM204.42 337l-.16-.2c0 .13.09.25.13.37zM204.87 338.5l-.12-.21c-.1-.18-.19-.37-.28-.55a3.5 3.5 0 0 1-.17.55c.14.15.29.29.44.43zM204.1 338.26a6.28 6.28 0 0 1-.47-.58 6.5 6.5 0 0 0 .46.61z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M202.67 335.37h.11a7.59 7.59 0 0 1-.07-1.07v-.48a4 4 0 0 1 .06-.71h-.09a7.24 7.24 0 0 0-.01 2.26zM204.55 335.8h.17c0-.63.05-1.25.08-1.81a4.7 4.7 0 0 1 .09-.92c0-.14.1-.37.28-.33s.17.19.21.28a5.23 5.23 0 0 1 .17 1c0 .3.08.6.12.9s.06.58.08.87h.15c0-.53-.09-1.06-.16-1.59 0-.19-.08-1.29-.43-1.65l-.51.05a3.17 3.17 0 0 0-.14 1.09c-.05.75-.06 1.43-.11 2.11zM202 335a5.93 5.93 0 0 1-.07-1c.09.41.21.81.34 1.21l.18.09a16.49 16.49 0 0 1-.48-1.66l-.16.14a8.4 8.4 0 0 0 0 1.12zM202.77 332.76a.13.13 0 0 0-.11.05l.12-.05zM203.35 334.05c.13.54.26 1.09.41 1.63h.17c-.09-.31-.17-.63-.25-.94a3.92 3.92 0 0 0-.61-1.72h-.11c.21.19.35.89.39 1.03z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M209.14 337.13l.15-.45a10.77 10.77 0 0 0 .36-1.19l-.28.13A9.71 9.71 0 0 1 209 337c-.13.32-.27.63-.43.94a10.58 10.58 0 0 0 .32-1.35 5.79 5.79 0 0 0 .37-1l-.19.08c0 .13-.08.26-.13.38a1.93 1.93 0 0 0 0-.34l-.14.05a4.47 4.47 0 0 1-.07.82 4.59 4.59 0 0 1-.42.66c.06-.45.09-.91.11-1.37h-.16c0 .53-.07 1.05-.14 1.58l-.05.06a6.73 6.73 0 0 0-.26-1.2l.26-.4-.22.05-.11.16v-.13h-.14a2.5 2.5 0 0 0 .07.26c-.21.3-.43.6-.66.89-.12-.35-.25-.7-.39-1h-.08c.11.39.24.77.38 1.14l-.44.54c-.17-.3-.34-.61-.53-.91a1.28 1.28 0 0 0 0-.19 5.62 5.62 0 0 0 .25-.56h-.2c0 .07-.06.15-.1.23a1.79 1.79 0 0 0 0-.23h-.15v.49c-.12-.17-.24-.34-.37-.5h-.12a7.24 7.24 0 0 0 .41.71.91.91 0 0 0-.07.14l-.38.73-.31-.39c-.12-.14-.23-.29-.34-.43s.06-.53.08-.8h-.18l-.06.6c-.11-.15-.23-.29-.35-.43a2.17 2.17 0 0 0-.07-.24h-.32c.08.13.17.25.26.38.11.34.23.68.37 1l-.09.38c0 .11-.07.21-.1.32a6.06 6.06 0 0 1-.89-1.19 4.91 4.91 0 0 1-.4-1.11h-.12a4.75 4.75 0 0 0 .44 1.19c-.15-.24-.28-.49-.41-.75l-.18-.5-.2-.08A6.92 6.92 0 0 0 203 337a9.45 9.45 0 0 0 1 1.42l-.15.34a1.13 1.13 0 0 1-.1-.13c-.26-.32-.51-.64-.75-1v-.1h-.05a10.33 10.33 0 0 1-.63-1c-.1-.37-.19-.72-.26-1.08l-.18-.11a4.74 4.74 0 0 0 .16.65c-.13-.25-.24-.51-.35-.77l-.16-.14a10 10 0 0 0 1.47 2.82c.11.38.23.74.37 1.1v.61a10.34 10.34 0 0 1-.09 1.57v.36c-.09.4-.32 1.6.27 1.18h.05a.73.73 0 0 0 .33.25.5.5 0 0 0 .51-.16c.14.23.33.45.58.44a.48.48 0 0 0 .37-.26.64.64 0 0 0 .1-.13.68.68 0 0 0 .92.16 1.44 1.44 0 0 0 .29-.31.74.74 0 0 0 .17.18c.36.25.52-.14.59-.41v-.1l.18.33c0 .05.12 0 .14 0a6.42 6.42 0 0 0 .09-1.75 5.68 5.68 0 0 1 .09-.84v-.06a7.54 7.54 0 0 1 .2-.82l.08-.13a9.07 9.07 0 0 0 .55-1.13v-.05-.11a10.66 10.66 0 0 0 1.41-2.72 1.84 1.84 0 0 1-.22.17 8.41 8.41 0 0 1-.84 1.86zm-1.4-.59a.42.42 0 0 0 0 .1 9.78 9.78 0 0 1 .2 1.08c-.18.21-.36.41-.56.61 0-.1-.07-.21-.11-.31l-.23-.63q.39-.39.7-.85zm-4.16 3c.07.17.15.33.22.5l-.2.22c0-.21-.07-.42-.1-.63zm-.09 0v-.28c0-.09.05.12.07.19zm.38.63c.07.15.15.3.23.45l-.33.38q-.09-.3-.15-.6zm1.66-.41l-.21-.19zm-.1-.31l.07-.08.4.45-.08.06a5.22 5.22 0 0 0-.39-.47zm.22.59l-.44.41-.32-.39.34-.39zm-.37-.75l-.44-.42.12-.2c.12.18.26.36.4.53zm-.1.12l-.09-.08-.33-.31c.14.08.24.21.42.35zm-.11.12l-.32.36-.32-.38.24-.35zm-.42.46l-.46.52c-.07-.15-.15-.29-.22-.44a4.11 4.11 0 0 0 .38-.45zm-.46.82l.25.44-.12.14-.29.36c-.07-.18-.14-.37-.2-.56zm.17 0l-.06-.12.5-.54.32.38c-.2.19-.39.39-.58.59zm.85-.16c.14.16.27.33.4.49l-.24.29c-.13.14-.25.29-.37.44-.13-.2-.25-.41-.37-.61.18-.26.37-.44.58-.64zm.1-.1l.27-.26.18-.16c.13.12.27.25.39.38l-.45.53zm1.57-.53l.37-.39.21.42-.3.41zm.14.61a1.13 1.13 0 0 0-.1.13l-.35-.4c.06-.07.12-.13.17-.2zm-.26-.79l-.27-.38.51-.46c.06.13.13.25.19.38zm-.13.14l-.2.22-.34-.36.29-.26c.08.09.16.23.25.42zm-.28.31l-.1.12-.07-.07a4.22 4.22 0 0 0-.27-.36l.09-.07c.11.09.23.22.35.35zm-.06.37a4.23 4.23 0 0 1 .33.41l-.11.12-.39.44a.61.61 0 0 0-.07-.1c-.08-.12-.17-.23-.26-.35zm.24.05a1.07 1.07 0 0 1-.14-.16l.1-.11c.12.14.23.28.35.41l-.1.12zm.39.25c.09.12.18.24.26.37s0 .11-.07.17a3.13 3.13 0 0 0-.29-.42zm.08-.09l.09-.11c.06.11.12.22.19.33v.1zm.23-.28c.1-.13.21-.26.3-.39v.06c-.06.19-.12.38-.19.57a.594.594 0 0 0-.11-.27zm.13-1.08l.24-.25c0 .13.09.26.14.39l-.18.25c-.06-.16-.13-.29-.2-.42zm-.1-.21c-.07-.12-.14-.24-.2-.37l.31-.3c0 .13.1.27.14.4zm-.27-1.75c.07.18.14.37.2.55s.09.25.13.38l-.33.33-.3-.54a2 2 0 0 1-.11-.2zm-.46.71c.12.22.24.43.35.65l-.47.44-.33-.46-.09-.11.49-.59zm-.56-.9l.42.67-.42.49c.03-.42.03-.8.03-1.19zm0 1.61l.34.48-.17.16-.13.11c-.14-.15-.27-.31-.4-.47l.31-.36a.35.35 0 0 0 .08.05zm-.58-1c.15-.27.3-.54.44-.82v1.42l-.45-.58zm-.09.15l.5.65c-.11.12-.21.24-.32.35-.14-.19-.28-.38-.41-.58zm-.69-.86l.24.29.36.46-.22.4a6.71 6.71 0 0 1-.44-.84zm-.33-.4l.16.2v.17c-.09-.23-.14-.31-.18-.44zm.21.95c.09.18.18.37.28.55l.12.21-.13.22c-.15-.14-.3-.28-.44-.43a3.5 3.5 0 0 0 .15-.62zm-.22.68c.13.15.27.29.41.43-.14-.14-.27-.28-.4-.43zm-.62-.74a6.28 6.28 0 0 0 .47.58 6.5 6.5 0 0 1-.49-.65zm.54.93c.12.14.25.27.38.4-.07.12-.15.23-.22.33a6.52 6.52 0 0 1-.34-.4 2.11 2.11 0 0 0 .16-.4zm-.25.45l.32.4c-.1.14-.22.28-.33.42-.08-.16-.15-.33-.22-.49a3.88 3.88 0 0 0 .21-.4zm-.72-.9l.6.76c-.05.11-.11.22-.17.33-.17-.43-.31-.8-.45-1.16zm.29 2.33c0 .21.1.41.16.61l-.25.31c0-.38.05-.68.07-.99zm-.2 1.52a1.89 1.89 0 0 0 .09.34c-.19-.19-.14-.22-.11-.42zm.29.4a2.32 2.32 0 0 1-.18-.83l.31-.31c.07.19.15.38.23.57l-.26.4c-.08.02-.09.08-.12.1zm.11.13c.06-.1.11-.21.16-.29s.11-.17.16-.25l.22.42.11.2c-.17.07-.36.11-.67-.15zm.59-.33a2.7 2.7 0 0 1-.17-.34l.32-.42.09-.1.36.62-.29.36c-.05.05-.09.12-.14.18-.08-.17-.14-.27-.19-.37zm.68.61c-.32 0-.33 0-.43-.17l.07-.08.37-.44c.12.19.24.38.38.56-.1.07-.09.07-.37.06zm.47-.27c-.09-.14-.17-.3-.23-.4l-.11-.16.63-.73.09.12.25.33a5.68 5.68 0 0 0-.44.56 2.75 2.75 0 0 0-.21.21zm1.17 0a.72.72 0 0 1-.87.3 1 1 0 0 1-.19-.17c.15-.22.27-.45.44-.66l.17-.2c.1.13.19.27.28.41a2.64 2.64 0 0 1 .18.3zm.08-.15a4.71 4.71 0 0 1-.45-.68l.5-.59c.11.15.22.31.32.47l-.3.65a1 1 0 0 0-.09.11zm.7-.15c0 .11 0 .23-.07.34-.25.11-.43.1-.53 0a5.38 5.38 0 0 0 .36-.82c.08.15.17.29.26.44s-.03-.02-.04 0zm.05-.31l-.23-.37.06-.15a2.68 2.68 0 0 1 .18.33c-.02.01-.02.08-.03.18zm0-.43l-.14-.24v-.09l.12.21a.49.49 0 0 0 .04.08zm0-.58l.06-.17v.26zm.25 1.51l-.18-.31v-.17a3 3 0 0 1 .13.39.43.43 0 0 0 .06.05zm0-.28a2.63 2.63 0 0 0-.17-.42.62.62 0 0 0 0-.13l.17.31a1.93 1.93 0 0 1 .05.2zm0-1.48v.93l-.15-.34c0-.27 0-.54.08-.81a.61.61 0 0 0 .07.14s.06.01.06.04zm0-.33l-.06-.13c0-.13.06-.25.1-.38v.08a3.21 3.21 0 0 0 .06.39zm0-1c0-.09-.06-.18-.1-.27l.21-.22c.07.13.03.29-.01.45zm.12.35v-.11zm.07-1.21l-.37.37c-.05-.13-.09-.26-.14-.4.18-.18.35-.37.52-.56v.46zm.25.07v.06l-.05.1v-.11l.1-.11zm-.06-.26c0-.25.09-.52.13-.78a5.72 5.72 0 0 0 .39-.57 11.72 11.72 0 0 1-.32 1.16 1.8 1.8 0 0 1-.1.15z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M206.41 335.19c-.06.23-.14.44-.22.66h.16a7.54 7.54 0 0 0 .29-.92c.13-.52.22-1.05.4-1.56.05-.14.11-.28.17-.42s.13-.45.23-.11a3.24 3.24 0 0 1 .05.76 16.74 16.74 0 0 0 .06 2.13h.15c-.09-.91 0-1.85-.09-2.78a1 1 0 0 0 0-.23l-.43-.05a3.74 3.74 0 0 0-.31.85c-.21.48-.31 1.1-.46 1.67zM208.16 335.6l.22-.06a.61.61 0 0 0 .07-.1 11.19 11.19 0 0 0 .6-1.2 5.85 5.85 0 0 1 .48-1.05 8.13 8.13 0 0 1-.28 2.07l.15-.08a7.22 7.22 0 0 0 .25-1.92l-.25-.12a13 13 0 0 0-.9 1.88c-.11.2-.22.39-.34.58zM209.65 333.15a.16.16 0 0 0 .12-.15.17.17 0 0 0-.17-.15.16.16 0 0 0-.16.16.43.43 0 0 0 0 .05v.08l.25.12zM205.2 332.53a.18.18 0 0 0-.18-.16.16.16 0 0 0-.16.17.14.14 0 0 0 0 .06.48.48 0 0 0-.09.11l.51-.05a.48.48 0 0 0-.08-.13zM207.54 332.55a.15.15 0 0 0 0-.13.18.18 0 0 0-.2-.09.17.17 0 0 0-.11.11.22.22 0 0 0 0 .08l-.08.1.43.05a.4.4 0 0 0-.04-.12zM202.71 333.05v.14h.09v-.07a.12.12 0 0 1 .13 0h.11a.86.86 0 0 0-.14-.13.15.15 0 0 0-.15-.16l-.12.05a.15.15 0 0 0 .08.17zM202 333.61v-.05a.08.08 0 0 0 0-.08.15.15 0 0 0-.15-.14.16.16 0 0 0-.16.15.17.17 0 0 0 .15.14.49.49 0 0 1 0 .12z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M202.83 333.08v.07l.17-.06a.12.12 0 0 0-.17-.01z'
        style={{
          fill: 'url(#s-68ff652d2d-ad)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M205.91 332.22a9.88 9.88 0 0 0-3.13.54.15.15 0 0 1 .15.16.86.86 0 0 1 .14.13 8.25 8.25 0 0 1 1.73-.38.48.48 0 0 1 .09-.11.14.14 0 0 1 0-.06.16.16 0 0 1 .16-.17.18.18 0 0 1 .18.16.48.48 0 0 1 .11.09h.61a12 12 0 0 1 1.23 0l.08-.1a.22.22 0 0 1 0-.08.17.17 0 0 1 .11-.11.18.18 0 0 1 .2.09.15.15 0 0 1 0 .13.4.4 0 0 1 0 .13 6.51 6.51 0 0 1 1.82.46v-.08a.43.43 0 0 1 0-.05.16.16 0 0 1 .16-.16.17.17 0 0 1 .17.15.16.16 0 0 1-.12.15v.11c.49.26.77.56.77.87s-.36.74-1 1.05l-.15.08a7.43 7.43 0 0 1-.87.28l-.22.06a3.4 3.4 0 0 1-.46.09h-.15a10.59 10.59 0 0 1-1.2.12h-1.77a5.77 5.77 0 0 1-.62-.09h-.17a5.76 5.76 0 0 1-1-.27h-.11l-.24-.1-.18-.09-.23-.22-.18-.14a.68.68 0 0 1 0-1.12.49.49 0 0 0 0-.12.17.17 0 0 1-.15-.14.16.16 0 0 1 .16-.15.15.15 0 0 1 .15.14.08.08 0 0 1 0 .08v.05a3.23 3.23 0 0 1 .75-.42v-.14a.15.15 0 0 1-.05-.24c-1 .38-1.56.92-1.55 1.52a1.14 1.14 0 0 0 .41.79l.16.14.19.12.18.11.34.16.2.08.15.06h.12a8.74 8.74 0 0 0 .85.22h.32l.48.07H206.64c.34 0 .67-.07 1-.12h.27l.22-.05h.35l.38-.11.14-.05h.13l.19-.08h.1l.28-.13a3.48 3.48 0 0 0 .43-.25 1.84 1.84 0 0 0 .22-.17 1.25 1.25 0 0 0 .5-.92c-.06-1.19-2.21-2.03-4.94-1.97z'
        style={{
          fill: 'url(#s-68ff652d2d-ae)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M865.68 139.13l2.47.01-1.1-1.43-2.66-.04 1.29 1.46z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M865.68 191.71l-1.29-3.93v-50.11l1.29 1.46v52.58z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M865.68 191.71l2.47.12v-52.69l-2.47-.01v52.58z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M865.68 147.9l-1.29-.71-8.59-14.14h.99l8.89 14.85z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M865.68 144.25v3.65l-8.88-14.85h-1v-2.33l1.68-.13 8.2 13.66z'
        style={{
          fill: '#333',
        }}
      />
      <g
        style={{
          isolation: 'isolate',
        }}
      >
        <path
          d='M853.99 124.64h.62v5.28h-.62z'
        />
        <path
          d='M854.02 124.98h.62v4.93h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M854.12 125.04h.62v4.84h-.62zM853.99 129.92h.62l.25 7.56h-.63l-.24-7.56z'
        />
        <path
          d='M854.02 129.91h.62l.24 7.18h-.62l-.24-7.18z'
          style={{
            fill: '#b4b4b4',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-af)',
            }}
          >
            <path
              d='M903.58 360.52h.62c-.18 1-.32 2.08-.43 3.16h-.62c.11-1.08.25-2.2.43-3.16'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-49.16 -239.04)'
            />
          </g>
        </g>
        <path
          d='M854.26 137.09h.62l.02.05h-.62l-.02-.05z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M854.12 129.88h.62l.22 6.94h-.62l-.22-6.94z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ag)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M903.86 359.31h.62c-.1.35-.19.76-.28 1.21h-.62a9.91 9.91 0 0 1 .28-1.21M903.58 360.52h.62c-.18 1-.32 2.08-.43 3.16h-.62c.11-1.08.25-2.2.43-3.16'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ah)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M903.87 359.76h.62c-.1.34-.19.74-.27 1.17h-.62c.08-.43.17-.83.27-1.17'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M903.6 360.93h.62c-.17.92-.3 2-.4 3h-.63c.1-1 .24-2.08.41-3'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <path
          d='M854.64 126.4h.62v8.6h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M854.82 127.94h.62v6.57h-.62z'
          style={{
            fill: '#121212',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ai)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M904 358.77h.63q-.09.24-.18.54h-.62a5 5 0 0 1 .17-.54M903.86 359.31h.62c-.1.35-.19.76-.28 1.21h-.62a9.91 9.91 0 0 1 .28-1.21'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aj)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M904.36 358.16h.64a1.47 1.47 0 0 0-.1.13h-.62l.09-.13M904.27 358.29h.62l-.1.18h-.63l.11-.18M904.16 358.47h.63a2.08 2.08 0 0 0-.13.3H904l.13-.3'
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904 358.77h.63q-.09.24-.18.54h-.62a5 5 0 0 1 .17-.54'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ak)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M904.37 358.64h.63l-.09.12h-.63a.58.58 0 0 1 .1-.12'
                style={{
                  fill: '#8a8a8a',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.27 358.76h.63l-.11.18h-.62l.1-.18'
                style={{
                  fill: '#8f8f8f',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.17 358.94h.62c0 .09-.08.18-.12.29H904c0-.11.09-.2.13-.29'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904 359.23h.63a5.46 5.46 0 0 0-.18.53h-.62a5.52 5.52 0 0 1 .17-.53'
                style={{
                  fill: '#999',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M903.87 359.76h.62c-.1.34-.19.74-.27 1.17h-.62c.08-.43.17-.83.27-1.17'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-al)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M904.68 358.46h.63a.43.43 0 0 0-.32.18h-.62a.41.41 0 0 1 .31-.18'
                style={{
                  fill: '#858585',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.37 358.64h.63l-.09.12h-.63a.58.58 0 0 1 .1-.12'
                style={{
                  fill: '#8a8a8a',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-am)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M904.68 358.46h.63a.43.43 0 0 0-.32.18h-.62a.41.41 0 0 1 .31-.18'
                style={{
                  fill: '#858585',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-an)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M904.68 358.9h.63a.39.39 0 0 0-.3.17h-.62a.39.39 0 0 1 .29-.17M904.39 359.07h.61l-.09.11h-.62l.09-.11M904.3 359.18h.62l-.09.17h-.63l.1-.17M904.2 359.35h.63q-.06.12-.12.27h-.62a1.69 1.69 0 0 1 .11-.27M904.09 359.62h.62a4.7 4.7 0 0 0-.16.49h-.63a4.65 4.65 0 0 1 .17-.49M903.92 360.11h.63c-.09.32-.18.7-.25 1.1h-.63c.08-.4.16-.78.25-1.1'
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M903.67 361.21h.63c-.17.87-.3 1.89-.4 2.87h-.62c.1-1 .23-2 .39-2.87'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ao)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M904.69 358h.63a.43.43 0 0 0-.33.18h-.63a.46.46 0 0 1 .33-.18'
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.36 358.16h.64a1.47 1.47 0 0 0-.1.13h-.62l.09-.13'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ap)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M855.52 119.86h.63-.63'
                style={{
                  fill: '#8f8f8f',
                }}
              />
              <path
                d='M904.69 358.9'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.72 358.9'
                style={{
                  fill: '#999',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.75 358.91'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.78 358.92'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.82 358.93h.62-.62'
                style={{
                  fill: '#a8a8a8',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.86 359H905.54h-.63'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.91 359h.63H904.95'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aq)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M855.52 119.42h.63-.63'
              />
              <path
                d='M904.82 358.49h.63-.62M904.87 358.51H905.55h-.63M904.92 358.55h.63l.05.05h-.6l-.06-.05'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ar)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M855.53 118.94h.63-.63'
                style={{
                  fill: '#8f8f8f',
                }}
              />
              <path
                d='M904.7 358'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.73 358'
                style={{
                  fill: '#999',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.77 358'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.8 358'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.84 358h.62-.63'
                style={{
                  fill: '#a8a8a8',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.88 358h.69-.69'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M904.94 358.07h.63v.05H905l-.06-.05'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-as)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M855.53 118.72h.63-.63'
              />
              <path
                d='M904.84 357.79h.62-.62M904.89 357.82H905.57 904.94M905 357.86H905.68h-.74'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-at)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905 357.9h.62-.62M905 357.94h.63a3.1 3.1 0 0 1 .45 1.07h-.62a2.89 2.89 0 0 0-.46-1.07'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-au)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905 358.12h.62-.62'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M905 358.16h.63a2.93 2.93 0 0 1 .44 1h-.63a2.75 2.75 0 0 0-.44-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-av)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905 359h.62-.62'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M905 359.06h.63a2.72 2.72 0 0 1 .39.93h-.62a2.51 2.51 0 0 0-.4-.93'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M905.39 360h.61a24.89 24.89 0 0 1 .59 3.35H906a26.6 26.6 0 0 0-.59-3.35'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M906 363.34h.62c.25 2 .44 4.49.53 7.16h-.63c-.09-2.67-.28-5.17-.52-7.16'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aw)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905 358.6h.62-.62M905 358.63h.63a2.87 2.87 0 0 1 .42 1h-.62a2.66 2.66 0 0 0-.43-1M905.44 359.63h.62a26.47 26.47 0 0 1 .62 3.5h-.62a28.25 28.25 0 0 0-.62-3.5M906.06 363.13h.62c.25 2.05.45 4.61.53 7.35h-.62c-.09-2.74-.28-5.3-.53-7.35'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ax)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905 358.16h.63a2.93 2.93 0 0 1 .44 1h-.63a2.75 2.75 0 0 0-.44-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-ay)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905 357.94h.63a3.1 3.1 0 0 1 .45 1.07h-.62a2.89 2.89 0 0 0-.46-1.07'
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M905.5 359h.62a26.89 26.89 0 0 1 .66 3.73h-.62a28.49 28.49 0 0 0-.66-3.73'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <path
          d='M854.64 135.01h.62l1.92 5.47h-.62l-1.92-5.47z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M854.82 134.51h.63l1.55 4.41h-.63l-1.55-4.41z'
          style={{
            fill: '#131313',
          }}
        />
        <path
          d='M854.82 127.94h.63l1.55 4.36h-.63l-1.55-4.36z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M856.37 132.3h.62v6.62h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M903.8 365.44l1.92 5.41v8.67l-1.92-5.47zm1.73 12.56v-6.62L904 367v6.57l1.55 4.41'
          style={{
            fill: '#151515',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M856.56 131.8h.62v8.68h-.62z'
          style={{
            fill: '#121212',
          }}
        />
        <path
          d='M854.64 126.41h.62l1.92 5.4h-.62l-1.92-5.4z'
          style={{
            fill: '#131313',
          }}
        />
        <path
          d='M854.23 137.48h.63l2.64 7.46h-.63l-2.64-7.46z'
        />
        <path
          d='M854.28 137.14h.62l2.52 7.11h-.63l-2.51-7.11z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M854.34 136.82h.62l2.41 6.8h-.62l-2.41-6.8z'
        />
        <path
          d='M857.26 137.64h.62l-.51 5.98h-.62l.51-5.98z'
          style={{
            fill: '#aeaeae',
          }}
        />
        <path
          d='M857.34 131.46h.62l-.08 6.18h-.62l.08-6.18z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M905 358.6c.7.63 1.42 5.84 1.61 11.88l-.08 6.27-.55 6.54-2.52-7.11v-.05l-.24-7.18v-5c.26-2.59.73-5.47 1.49-5.47a.42.42 0 0 1 .29.12zm1.44 18.08l.08-6.18c-.19-5.83-.87-10.87-1.54-11.47a.42.42 0 0 0-.28-.13c-.72 0-1.15 2.72-1.4 5.18v4.84l.22 6.94 2.41 6.8.51-6'
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M856.37 132.3v6.62l-1.55-4.41v-6.57l1.55 4.36z'
          style={{
            fill: '#d0d0d0',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-az)',
            }}
          >
            <path
              d='M905.5 359h.62a26.89 26.89 0 0 1 .66 3.73h-.62a28.49 28.49 0 0 0-.66-3.73'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-49.16 -239.04)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aA)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905 358.16h.63a2.93 2.93 0 0 1 .44 1h-.63a2.75 2.75 0 0 0-.44-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M905.47 359.19h.63a27.93 27.93 0 0 1 .64 3.66h-.62a26.08 26.08 0 0 0-.65-3.66'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aB)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905.47 359.19h.63a27.93 27.93 0 0 1 .64 3.66h-.62a26.08 26.08 0 0 0-.65-3.66'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-49.16 -239.04)'
              />
              <path
                d='M906.12 362.85h.62c.27 2.16.47 4.89.57 7.79h-.62c-.1-2.9-.31-5.63-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aC)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M905.5 359h.62a26.89 26.89 0 0 1 .66 3.73h-.62a28.49 28.49 0 0 0-.66-3.73M906.16 362.74h.62c.27 2.2.48 4.95.57 7.89h-.62c-.1-2.94-.3-5.69-.57-7.89'
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <path
          d='M857.35 137.71h.62l-.55 6.54h-.63l.56-6.54zM857.43 131.44h.62l-.08 6.27h-.62l.08-6.27z'
        />
        <path
          d='M905 358.12c.74.67 1.48 6.16 1.69 12.52l-.09 6.73-.6 6.63-2.65-7.46-.24-7.56v-5.28c.27-2.7.75-5.7 1.54-5.7a.45.45 0 0 1 .35.12zm1.51 18.63l.08-6.27c-.19-6-.91-11.25-1.61-11.88a.42.42 0 0 0-.3-.14c-.76 0-1.23 2.88-1.49 5.47v5l.24 7.18v.05l2.52 7.11.55-6.54'
          style={{
            fill: '#d0d0d0',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aD)',
            }}
          >
            <path
              d='M906.16 362.74h.62c.27 2.2.48 4.95.57 7.89h-.62c-.1-2.94-.3-5.69-.57-7.89'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-49.16 -239.04)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aE)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M906.12 362.85h.62c.27 2.16.47 4.89.57 7.79h-.62c-.1-2.9-.31-5.63-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aF)',
            }}
          >
            <path
              d='M906.16 362.74h.62c.27 2.2.48 4.95.57 7.89h-.62c-.1-2.94-.3-5.69-.57-7.89'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-49.16 -239.04)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aG)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M906.12 362.85h.62c.27 2.16.47 4.89.57 7.79h-.62c-.1-2.9-.31-5.63-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <path
          d='M857.44 138.33h.62l-.56 6.61h-.63l.57-6.61z'
          style={{
            fill: '#aeaeae',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aH)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M906.12 362.85h.62c.27 2.16.47 4.89.57 7.79h-.62c-.1-2.9-.31-5.63-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aI)',
            }}
          >
            <path
              d='M906.16 362.74h.62c.27 2.2.48 4.95.57 7.89h-.62c-.1-2.94-.3-5.69-.57-7.89'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-49.16 -239.04)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-68ff652d2d-aJ)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M906.12 362.85h.62c.27 2.16.47 4.89.57 7.79h-.62c-.1-2.9-.31-5.63-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-49.16 -239.04)'
              />
            </g>
          </g>
        </g>
        <path
          d='M857.52 131.6h.63l-.09 6.73h-.62l.08-6.73z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M905 357.9c.75.69 1.51 6.26 1.72 12.73l-.09 6.77-.58 6.9-2.69-7.61-.26-7.69v-5.33c.29-2.81.78-5.89 1.59-5.89a.53.53 0 0 1 .31.12zm1.59 19.47l.09-6.73c-.21-6.36-1-11.85-1.69-12.52a.45.45 0 0 0-.31-.14c-.79 0-1.27 3-1.54 5.7V369l.24 7.56L906 384l.56-6.61'
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M905 359c.67.6 1.35 5.64 1.54 11.47l-.08 6.18-.51 6-2.41-6.8-.22-6.94v-4.84c.25-2.46.68-5.18 1.4-5.18a.42.42 0 0 1 .28.11zm.76 20.49v-8.67l-1.92-5.41v8.61l1.92 5.47'
          style={{
            fill: '#d0d0d0',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M857.48 138.36h.62l-.58 6.9h-.62l.58-6.9zM857.57 131.59h.62l-.09 6.77h-.62l.09-6.77z'
        />
      </g>
      <path
        d='M856.05 140.77l-.62-1.72.1-2.84.55 1.29-.03 3.27z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M904.27 376.61a.59.59 0 0 0-.17-1c-.76-.45-1-.34-1-.34h1.59l.54 1.29z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M904.58 378.57l-6.64-4.07a.16.16 0 0 1-.13-.17.17.17 0 0 1 .19-.13l6.63 4.07a.16.16 0 0 1 .13.18.15.15 0 0 1-.18.12z'
        style={{
          fill: 'url(#s-68ff652d2d-aK)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M903.5 378.43q.11-.36.18-.75l.21-.14c-.12.3-.25.6-.39.89zM902.64 378.66c-.15.3-.31.59-.48.88a5.54 5.54 0 0 0 .51-1.39l.18-.06zM897.26 381.11c-.22-.22-.44-.46-.64-.7 0-.42.14-.83.23-1.24v-.12c.24.34.49.67.75 1-.08.25-.17.49-.26.73zM901.59 377c-.1.37-.19.73-.29 1.09l-.72.11c-.05-.79-.07-1.58-.13-2.37a3.63 3.63 0 0 0-.16-1.25 9.81 9.81 0 0 1 2 .43 4.45 4.45 0 0 0-.7 1.99zM902.06 379.48a6 6 0 0 1-1 1.37c0-.12-.08-.24-.11-.36s-.08-.29-.11-.44c.16-.38.3-.76.43-1.16l.3-.44a8.23 8.23 0 0 0 1-.25 5.06 5.06 0 0 1-.51 1.28zM896.78 378.85a7 7 0 0 0-.31 1.39l-.06-.08c-.08-.6-.13-1.21-.15-1.82h.21zM899.29 377.23c0-.34.08-.69.13-1a6.21 6.21 0 0 1 .2-1.22c0-.09.14-.29.24-.32s.28.22.33.38a6.36 6.36 0 0 1 .1 1.07c0 .64.05 1.36.09 2.08a11.16 11.16 0 0 1-1.18.05c.02-.37.05-.7.09-1.04zM899 378.66v.27l-.11-.27h.11zM896.2 379.88a7 7 0 0 1-.49-.76 6.08 6.08 0 0 1-.07-.95l.43.12c.02.53.06 1.06.13 1.59zM896.86 378.62l-.12-.19h.15c-.02.08-.02.14-.03.19zM899.14 379.23v-.57h.4a6.07 6.07 0 0 0-.4.57zM901.09 378.79c-.14.16-.27.33-.4.49 0-.23-.05-.46-.07-.69l.55-.07a2.76 2.76 0 0 0-.08.27zM900.5 379.53l-.39.5-.36.45-.44-.85-.08-.15c.17-.27.33-.55.47-.83h.7c.02.27.05.57.1.88zM899 379.3a1.62 1.62 0 0 0 0 .22c-.22.35-.42.7-.61 1.05l-.51-.62c.16-.44.31-.88.44-1.32h.4c.04.24.13.46.28.67zM895.47 378.5c-.06-.14-.1-.29-.15-.44l.15.05a2.54 2.54 0 0 0 0 .39zM897.72 379.81q-.39-.49-.75-1c0-.1 0-.2.07-.3a9.91 9.91 0 0 0 1.14.13c-.18.36-.32.77-.46 1.17zM896.94 378l-.53-.1c-.14-.23-.27-.45-.39-.68a14.46 14.46 0 0 0-1-2.17 7.89 7.89 0 0 1 2.1-.54v.28c-.19 1.11-.07 2.21-.18 3.21zM893.79 376.23c0-.35.33-.7.89-1a9.07 9.07 0 0 0 .29 2.22c-.76-.36-1.19-.8-1.18-1.22zM903.17 379.05c-.23.39-.47.78-.73 1.15h-.05v.12c-.27.39-.56.76-.86 1.13l-.11.15c-.06-.13-.13-.26-.18-.39a11.17 11.17 0 0 0 1.18-1.64 7.57 7.57 0 0 0 .69-1.54l.38-.19c-.11.38-.21.79-.32 1.21zM903.55 377.25a3 3 0 0 1-.32.2c.16-.46.29-.92.41-1.4a7.88 7.88 0 0 1-.09 1.2zM899 378.23h-.34c-.09-.25-.18-.5-.25-.76-.18-.65-.29-1.33-.49-2a4.38 4.38 0 0 0-.37-1 13.09 13.09 0 0 1 1.42 0h.71c-.4.42-.46 1.68-.5 1.91q-.1.94-.18 1.85zM897.19 375.61a3.16 3.16 0 0 1 0-.87c.11-.4.18-.06.26.12a4.19 4.19 0 0 1 .2.49c.2.59.32 1.2.46 1.8.09.36.21.72.33 1.07q-.74 0-1.38-.15a22.3 22.3 0 0 0 .13-2.46zM902.76 377.67a8.87 8.87 0 0 0 0-2.52 3.61 3.61 0 0 1 .86.49c-.15.64-.34 1.28-.55 1.91zM895.9 380.64c-.18-.36-.35-.72-.5-1.09a11 11 0 0 1-.41-1.62h.11a6.39 6.39 0 0 0 .43 1.11 12.18 12.18 0 0 0 .37 1.6z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M852.21 139.44z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M895.11 379.18c0 .17.1.35.16.52a9.77 9.77 0 0 1-1.1-2.22 3 3 0 0 0 .5.3 11 11 0 0 0 .44 1.4zM894.83 375.16a6.48 6.48 0 0 1 .54 1.2 13.89 13.89 0 0 0 .7 1.39l.08.12a8.38 8.38 0 0 1-1-.33 8.8 8.8 0 0 1-.32-2.38zM899.53 381.93l-.37-.41.57-.75.27.48c-.15.23-.31.46-.47.68zM896.24 380.19c0 .3.09.6.14.91l-.23-.23c-.14-.44-.27-.89-.37-1.34a7.75 7.75 0 0 0 .46.66zM897.2 381.28c-.06.15-.12.3-.17.46-.14-.15-.29-.29-.43-.43v-.15-.53c.19.22.4.44.6.65zM902.7 376.48a7.31 7.31 0 0 1-.07 1.24 7.8 7.8 0 0 1-1.14.31c.17-.63.33-1.27.48-1.89 0-.16.2-1 .45-1.11l.2.08a5.25 5.25 0 0 1 .06.82c.01.18.02.37.02.55zM898.94 379.94v1.33l-.49-.56c.16-.26.32-.52.49-.77zM899.84 380.64l.41-.53.29-.34.06.36a9.83 9.83 0 0 1-.5 1zM903.76 375.79a1 1 0 0 1 .34.67 1 1 0 0 1-.35.63 8.08 8.08 0 0 0 .01-1.3zM899.13 379.65l.5.94c-.18.22-.35.45-.52.67 0-.52 0-1.07.02-1.61zM897.76 381.61l-.39-.38c0-.15.1-.29.16-.44l.22-.64.49.6c0 .08-.09.16-.13.24s-.24.41-.35.62zM900.72 379.54c.07-.07.13-.15.2-.23l-.16.43a1.42 1.42 0 0 0-.04-.2zM900.2 381.28l.15-.24c.11-.21.22-.42.32-.63a4.61 4.61 0 0 0 .2.63l-.51.5zM901.1 381c.19-.22.38-.44.55-.67-.17.24-.35.47-.54.7z'
        style={{
          fill: 'none',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M902.76 377.67l-.13.05a7.31 7.31 0 0 0 .07-1.24v-.55a5.25 5.25 0 0 0-.06-.82h.1a8.87 8.87 0 0 1 .02 2.56zM900.58 378.17h-.2c0-.72 0-1.44-.09-2.08a6.36 6.36 0 0 0-.1-1.07c-.05-.16-.12-.43-.33-.38s-.2.23-.24.32a6.21 6.21 0 0 0-.2 1.22c0 .35-.09.7-.13 1s-.07.67-.09 1h-.2q.06-.92.18-1.83c0-.23.1-1.49.5-1.91l.59.06a3.63 3.63 0 0 1 .16 1.25c.08.84.1 1.63.15 2.42zM903.55 377.25a7.88 7.88 0 0 0 .09-1.2c-.12.48-.25.94-.41 1.4l-.2.1c.21-.63.4-1.27.55-1.91l.18.15a8.08 8.08 0 0 1 0 1.3 1.16 1.16 0 0 1-.21.16zM902.63 374.65a.15.15 0 0 1 .13.06l-.14-.06zM902 376.14c-.15.62-.31 1.26-.48 1.89h-.19c.1-.36.19-.72.29-1.09a4.45 4.45 0 0 1 .7-2h.13c-.28.24-.45 1.06-.45 1.2z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M894.17 377.48a1.64 1.64 0 0 1-.25-.19 12.16 12.16 0 0 0 1.62 3.14 1.12 1.12 0 0 0 .05.13.08.08 0 0 0 0 .05 12.16 12.16 0 0 0 .64 1.31l.09.14c.09.31.17.63.24.95a.06.06 0 0 0 0 .07 6.4 6.4 0 0 1 .11 1 7.25 7.25 0 0 0 .1 2 .09.09 0 0 0 .16 0l.21-.38v.11c.07.32.26.77.67.48a.7.7 0 0 0 .21-.21 1.27 1.27 0 0 0 .33.36.79.79 0 0 0 1.07-.19l.11.15a.55.55 0 0 0 .43.3c.29 0 .5-.25.66-.51a.6.6 0 0 0 .6.18.75.75 0 0 0 .38-.28c.69.48.42-.89.32-1.37a2.93 2.93 0 0 0 0-.41 13.73 13.73 0 0 1-.1-1.81 5.3 5.3 0 0 0 0-.69c.16-.42.3-.84.43-1.27a11.91 11.91 0 0 0 1.72-3.22l-.19.16c-.12.3-.25.6-.39.89q.11-.36.18-.75l-.22.13c-.08.41-.18.82-.29 1.24s-.47.78-.73 1.15h-.05v.12c-.27.39-.56.76-.86 1.13l-.11.15c-.06-.13-.13-.26-.18-.39a11.17 11.17 0 0 0 1.18-1.64 7.57 7.57 0 0 0 .69-1.54l-.23.09-.21.57c-.15.3-.31.59-.48.88a5.54 5.54 0 0 0 .51-1.39l-.14.05a5.06 5.06 0 0 1-.47 1.28 6 6 0 0 1-1 1.37c0-.12-.08-.24-.11-.36s-.08-.29-.11-.44c.16-.38.3-.76.43-1.16l.3-.44h-.38a2.76 2.76 0 0 0-.08.27c-.14.16-.27.33-.4.49 0-.23-.05-.46-.07-.69h-.22c0 .31.05.61.1.92l-.39.5-.36.45-.44-.85-.08-.15c.17-.27.33-.55.47-.83h-.13a6.07 6.07 0 0 0-.43.57v-.57H899v.27l-.11-.27h-.19c.09.22.18.44.29.65a1.62 1.62 0 0 0 0 .22c-.22.35-.42.7-.61 1.05l-.51-.62c.16-.44.31-.88.44-1.32h-.09c-.17.39-.32.79-.46 1.19q-.39-.49-.75-1c0-.1 0-.2.07-.3h-.16v.16l-.12-.19-.26-.06.31.47a7 7 0 0 0-.31 1.39l-.06-.08c-.08-.6-.13-1.21-.15-1.82h-.19c0 .53.06 1.06.13 1.59a7 7 0 0 1-.49-.76 6.08 6.08 0 0 1-.07-.95l-.17-.06a2.54 2.54 0 0 0 0 .39c-.06-.14-.1-.29-.15-.44l-.22-.09a6.39 6.39 0 0 0 .43 1.11 12.18 12.18 0 0 0 .37 1.56c-.18-.36-.35-.72-.5-1.09a11 11 0 0 1-.41-1.62l-.32-.15a11 11 0 0 0 .43 1.38c0 .17.1.35.16.52a9.77 9.77 0 0 1-1.16-2.18zm3.48 2.54c-.08.25-.17.49-.26.73l-.13.36c-.22-.22-.44-.46-.64-.7 0-.42.14-.83.23-1.24v-.12c.29.31.54.64.8.95zm4.14 2.52c0 .25-.07.49-.11.73l-.24-.26c.09-.18.17-.37.26-.56zm0-.21l.09-.22v.33zm-.09 1.1c0 .24-.1.47-.17.7-.12-.15-.25-.29-.38-.44.09-.17.18-.34.26-.51zm-2-1l-.24.21zm-.57.38l-.09-.08c.16-.17.31-.34.46-.52l.08.09c-.17.2-.33.37-.47.54zm.68-.24l.4.44-.38.45-.5-.47zm-.15-.55a7.21 7.21 0 0 0 .47-.62 1.71 1.71 0 0 0 .13.23c-.17.17-.34.33-.5.5zm.69-.23c-.13.12-.25.25-.38.36l-.1.09zm.12.18a3.62 3.62 0 0 0 .27.41c-.13.14-.25.29-.37.43l-.37-.41zm.36.54a5.27 5.27 0 0 0 .43.51c-.08.17-.16.34-.25.51l-.53-.6zm.61 1.81a5.78 5.78 0 0 1-.25.65 4.63 4.63 0 0 0-.32-.42l-.15-.17c.1-.16.2-.33.29-.5zm-.83-.07c-.22-.23-.44-.46-.67-.68l.37-.44.58.62-.07.14zm-.1.16c-.14.24-.28.47-.43.7l-.43-.51-.27-.32.45-.58c.22.3.44.5.66.74zm-1.24-.25c-.17-.21-.35-.41-.53-.61l.47-.45a1.8 1.8 0 0 0 .2.19l.31.31zm-1.68-.67l-.36-.47.25-.5c.14.16.29.31.43.46-.13.2-.24.37-.34.54zm.47-.34l.21.22a5.72 5.72 0 0 0-.4.46l-.12-.14c.08-.16.19-.34.25-.51zm-.46-.86l.23-.45c.17.17.35.33.53.49-.11.14-.21.29-.31.44zm.9.17l.33.3-.39.42c-.08-.09-.16-.17-.23-.26a4.66 4.66 0 0 1 .27-.43zm.43.39l.09.09c-.11.13-.21.27-.31.41l-.07.08-.12-.14c.11-.12.25-.29.39-.41zm.21 1.48l-.3.41a1 1 0 0 0-.08.11l-.45-.5-.13-.15a5.71 5.71 0 0 1 .39-.47zm-1.07-.26a.69.69 0 0 1-.11-.13c.13-.16.26-.32.4-.47l.12.12-.17.19zm-.1.13l-.34.48-.07-.19a3.19 3.19 0 0 1 .3-.42zm-.48.13v-.12l.21-.38.11.13c-.16.15-.25.27-.34.4zm-.15-.41c-.08-.22-.15-.45-.22-.67v-.06c.11.15.23.3.35.44zm-.23-1.07l-.19-.29c.06-.15.12-.3.17-.45l.27.28zm.06-1c.06-.15.11-.31.17-.46.11.12.24.23.36.35l-.23.43zm1.09-1.11c0 .08-.09.16-.13.24s-.24.41-.35.62l-.39-.38c0-.15.1-.29.16-.44l.22-.64zm.11.14c.18.23.37.45.56.68a1.47 1.47 0 0 1-.1.13l-.38.53-.54-.5c.13-.25.26-.5.4-.75zm.59.38l-.49-.56c.16-.26.32-.52.49-.77-.03.45-.03.9-.02 1.34zm.08.43l.36.42-.47.55-.14-.14-.2-.18c.12-.19.25-.37.39-.56zm.63-1.09c-.18.22-.35.45-.52.67v-1.63l.5.94zm.35.64c-.15.23-.31.46-.47.68l-.37-.41.57-.75zm.6-1.12a9.83 9.83 0 0 1-.5 1l-.26-.46.41-.53.29-.34zm.16-.39a1.42 1.42 0 0 0 0-.2c.07-.07.13-.15.2-.23zm.11 1.3l-.51.5-.16-.26.15-.24c.11-.21.22-.42.32-.63a4.61 4.61 0 0 0 .18.6zm.07.2c-.14.17-.3.34-.46.5v-.05l.48-.49zm.17-.2c.19-.22.38-.44.55-.67-.2.22-.38.45-.57.64zm.11.76l-.38.46-.27-.38c.16-.15.3-.31.45-.47.04.15.11.27.18.4zm.36.51c-.08.19-.17.38-.26.57l-.39-.49.38-.45a3.18 3.18 0 0 0 .25.38zm.06-.16l-.2-.38c.24-.29.47-.58.7-.88-.16.43-.34.86-.52 1.27zm.26 2.5l-.29-.36a5.56 5.56 0 0 0 .19-.7c.01.36.07.72.08 1.07zm0 1.07a2.38 2.38 0 0 0 .11-.38c.04.23.1.27-.1.39zm-.34-.11c-.1-.16-.2-.31-.31-.46.1-.22.19-.44.27-.67l.35.36a2.31 2.31 0 0 1 0 .37 1.81 1.81 0 0 1-.17.59s-.07-.08-.13-.18zm-.77.44l.13-.24c.09-.15.17-.32.25-.48l.19.29c.06.09.11.22.18.33-.35.32-.56.27-.74.11zm-.12-.13l-.17-.21-.33-.41c.14-.24.27-.49.41-.72l.1.12a4.45 4.45 0 0 1 .38.48c-.06.13-.12.26-.19.39zm-1.05.2a5.58 5.58 0 0 0 .44-.64l.43.51.08.09c-.12.19-.13.2-.49.2s-.36.02-.45-.15zm-.3-.48c-.16-.22-.33-.43-.51-.64l.28-.39.1-.13c.25.27.49.55.73.83l-.12.2c-.07.12-.16.29-.27.46zm-1.15.33l.2-.34c.11-.16.21-.32.33-.48l.19.24a6.3 6.3 0 0 1 .51.76.77.77 0 0 1-.22.19.82.82 0 0 1-1-.34zm-.16-.31c-.12-.25-.24-.5-.35-.76l.37-.54.58.68a6.34 6.34 0 0 1-.52.79c-.02-.05-.04-.11-.11-.16zm-.75-.08l.3-.51a6.49 6.49 0 0 0 .41.95c-.12.14-.32.15-.61 0l-.09-.39v-.04zm-.06-.53c.06-.13.13-.25.2-.37a1.22 1.22 0 0 1 .07.17l-.26.43a2.11 2.11 0 0 1 0-.22zm0-.39l.13-.24v.1a2.54 2.54 0 0 0-.16.28.66.66 0 0 1 .01-.13zm0-.43v-.3c0 .07.05.13.07.2s-.1.08-.12.11zm-.25 1.58a3.53 3.53 0 0 1 .15-.46v.19l-.2.36a.13.13 0 0 1 0-.08zm-.06-.54l.2-.36v.15a4.14 4.14 0 0 0-.19.49c-.05-.08-.05-.17-.06-.27zm0-1.52c0-.05 0-.11.08-.16 0 .31.07.62.09.93-.06.13-.12.26-.17.4v-1.08a.28.28 0 0 1-.05-.08zm-.11-.78v-.1c0 .15.08.29.11.44l-.06.15c-.04-.16-.07-.32-.1-.45zm-.06-1.23l.24.26c0 .1-.07.2-.11.31-.09-.18-.14-.37-.18-.56zm0 .81l.05.06v.06c-.11-.01-.13-.06-.14-.11zm-.08-1.39v-.53c.19.22.39.44.6.65-.06.15-.12.3-.17.46-.14-.15-.29-.29-.43-.43zm-.28.16l.12.12v.14l-.06-.12a.21.21 0 0 0 0-.06zm-.14-.45c-.14-.44-.27-.89-.37-1.34a7.75 7.75 0 0 0 .46.66c0 .3.09.6.14.91z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M898.43 377.46c.07.26.16.51.25.76h-.19c-.12-.35-.24-.71-.33-1.07-.14-.6-.26-1.21-.46-1.8a4.19 4.19 0 0 0-.2-.49c-.08-.18-.15-.52-.26-.12a3.16 3.16 0 0 0 0 .87 22.3 22.3 0 0 1-.08 2.46h-.17c.11-1.06 0-2.14.1-3.21v-.28l.5-.05a4.38 4.38 0 0 1 .37 1c.18.6.29 1.28.47 1.93zM896.41 377.94l-.26-.07-.08-.12a13.89 13.89 0 0 1-.7-1.39 6.48 6.48 0 0 0-.54-1.2 8.8 8.8 0 0 0 .32 2.38l-.18-.09a9.07 9.07 0 0 1-.29-2.22l.29-.14a14.46 14.46 0 0 1 1 2.17c.17.23.3.45.44.68z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M894.68 375.1a.16.16 0 0 1-.13-.17.19.19 0 0 1 .19-.17.19.19 0 0 1 .19.18.14.14 0 0 1 0 .06l.06.09-.29.14zM899.83 374.39a.09.09 0 0 1 0-.05.2.2 0 0 1 .39 0 .24.24 0 0 1 0 .08.4.4 0 0 1 .1.12l-.59-.06a.41.41 0 0 1 .1-.09zM897.12 374.41a.2.2 0 0 1 0-.15.2.2 0 0 1 .24-.1.18.18 0 0 1 .13.12.17.17 0 0 1 0 .1l.09.11-.5.05a.58.58 0 0 1 .04-.13zM902.7 375v.17h-.1v-.09a.14.14 0 0 0-.15 0h-.13a1.07 1.07 0 0 1 .16-.14.17.17 0 0 1 .17-.19l.14.06a.16.16 0 0 1-.09.19zM903.58 375.64v-.06a.17.17 0 0 1 .15-.26.18.18 0 0 1 .18.17.17.17 0 0 1-.17.16v.14z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M902.57 375v.09l-.2-.08a.14.14 0 0 1 .2-.01z'
        style={{
          fill: 'url(#s-68ff652d2d-aL)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M899 374a11.26 11.26 0 0 1 3.62.62.17.17 0 0 0-.17.19 1.07 1.07 0 0 0-.16.14 9.81 9.81 0 0 0-2-.43.4.4 0 0 0-.1-.12.24.24 0 0 0 0-.08.2.2 0 0 0-.39 0 .07.07 0 0 0 0 .05.41.41 0 0 0-.13.1h-.71a13.09 13.09 0 0 0-1.42 0l-.09-.11a.17.17 0 0 0 0-.1.16.16 0 0 0-.13-.12.2.2 0 0 0-.24.1.19.19 0 0 0 0 .15.58.58 0 0 0 0 .14 7.89 7.89 0 0 0-2.1.54l-.06-.09a.14.14 0 0 0 0-.06.19.19 0 0 0-.19-.18.19.19 0 0 0-.19.17.16.16 0 0 0 .13.17v.13c-.56.3-.88.65-.89 1s.42.86 1.18 1.22l.18.09a8.38 8.38 0 0 0 1 .33l.26.07.53.1h.17q.64.1 1.38.15h.71a11.16 11.16 0 0 0 1.18-.05h.2l.72-.11h.19a7.8 7.8 0 0 0 1.14-.31l.13-.05.27-.12.2-.1a3 3 0 0 0 .32-.2 1.16 1.16 0 0 0 .2-.16 1 1 0 0 0 .35-.63 1 1 0 0 0-.34-.67v-.14a.17.17 0 0 0 .17-.16.18.18 0 0 0-.18-.17.17.17 0 0 0-.15.26v.06a3.61 3.61 0 0 0-.86-.49v-.17a.16.16 0 0 0 .06-.27c1.12.44 1.81 1.07 1.79 1.76a1.31 1.31 0 0 1-.47.91l-.19.16-.21.14-.22.13-.38.19-.23.09-.18.06-.14.05a8.23 8.23 0 0 1-1 .25h-.38l-.55.07H898.22a9.91 9.91 0 0 1-1.14-.13h-.31l-.26-.06h-.4l-.43-.12-.17-.06-.15-.05-.22-.09h-.11l-.32-.15a3 3 0 0 1-.5-.3 1.64 1.64 0 0 1-.25-.19 1.38 1.38 0 0 1-.58-1.07c-.01-1.36 2.48-2.28 5.62-2.28z'
        style={{
          fill: 'url(#s-68ff652d2d-aM)',
        }}
        transform='translate(-49.16 -239.04)'
      />
      <path
        d='M900.52 378.63a.17.17 0 0 1-.13 0 .16.16 0 0 1 0-.22l4.57.07a.18.18 0 0 1 .23 0 .14.14 0 0 1 0 .21l-4.57-.07a.18.18 0 0 1-.1.01z'
        style={{
          fill: 'url(#s-68ff652d2d-aN)',
        }}
        transform='translate(-49.16 -239.04)'
      />
    </g>
    <g
      id='tennisNet'
    >
      <path
        d='M506.63 124.8l-67.54 99.33'
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M506.15 123.24l-67.06 98.45M506.15 121.27l-67.06 98.45M506.15 119.35l-67.06 98.46M506.15 117.39l-67.06 98.45M506.15 115.44l-67.06 98.45M506.15 113.47l-67.06 98.45M506.15 111.55l-67.06 98.46M506.15 109.59l-67.06 98.45M506.15 107.7l-67.06 98.46M506.15 105.74l-67.06 98.45M506.15 103.82l-67.06 98.45M441.06 196.51v24.7M442.24 194.89v24.61M443.52 193.23l-.04 24.45M444.81 191.04l-.05 23.94M445.99 189.51l-.04 23.59M447.27 187.85l-.04 23.31M448.64 185.68l-.04 24.65M449.83 183.35l-.04 25.1M451.11 181.7l-.05 24.8M452.39 179.51v24.78M453.58 177.98v24.43M454.86 176.32v24.15M456.17 174.65l.04 23.94M457.36 172.89l.04 23.82M458.64 171.04l.04 23.73M459.92 169.16l.04 24.05M461.11 167.42l.05 23.05M462.39 164.96l.05 23.57M463.56 163.84l.06 24.04M464.74 162.13l.01 23.93M466.02 160.23l.01 23.94M467.31 158.35v24.34M468.5 156.62v24.33M469.78 154.74v24.34M471.15 152.06v24.8M472.33 151l.01 24.28M473.61 149.13l.01 24.13M474.9 147.25v24.05M476.09 145.51v24.08M477.37 143.63v23.92M478.68 141.75v23.85M479.87 139.39v24.49M481.19 137.97l-.05 24.08M482.48 135.78l-.05 24.73M483.67 134.25l-.06 24.56M484.9 132.61v24.06M486.14 130.78v24.08M487.52 128.71v24.2M488.7 127.04v24.12M489.98 125.17v23.78M491.27 123.29v24.11M492.45 121.55v23.97M493.73 119.68v23.9M495.05 117.75v24.22M496.23 116.02v24.07M497.51 114.14v24M498.8 112.26v24.33M499.98 110.53v24.18M501.26 108.66v24.11M503.49 105.39v24.48M504.77 103.52v24.41'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
        }}
      />
      <path
        d='M444.98 215.48v-24.64'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-68ff652d2d-aO)',
        }}
      />
      <path
        d='M502.09 131.47v-24.03'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-68ff652d2d-aP)',
        }}
      />
      <path
        d='M506.63 124.8v-24l-67.54 98.86v24.47'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-68ff652d2d-aQ)',
        }}
      />
      <path
        d='M439.09 227.38v-27.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-68ff652d2d-aR)',
        }}
      />
      <path
        d='M506.63 127.18V100.6'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-68ff652d2d-aS)',
        }}
      />
    </g>
    <g
      id='unihockey'
    >
      <g
        id='unihockeyRight'
      >
        <path
          d='M847.19 206.42l-50.84-3.29-4.08-32.28 45.55 2.72 9.37 32.85z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M835.22 198.36l10.95.62v-1l-6.54-19.45-9.71.21v1l8.5.47 5.45 17.05-8.65.1v1z'
          style={{
            fill: 'url(#s-68ff652d2d-g)',
          }}
        />
        <path
          d='M835.24 197.36l10.93.62-6.54-19.45-10.16-.47.53.68 9.02.51 5.87 18.06-9.86-.56.21.61z'
          style={{
            fill: 'url(#s-68ff652d2d-aT)',
          }}
        />
        <path
          d='M888.33 418.57c-1 0-2.08-.05-3.29-.14v-.1a36.14 36.14 0 0 0 7-.07v.1a34 34 0 0 1-3.71.21zM888.28 418c-1 0-2-.05-3.19-.13v-.1a33.29 33.29 0 0 0 6.73-.08v.1a32 32 0 0 1-3.54.21zM888.32 419.62c-1.07 0-2.17-.05-3.37-.13v-.1a39.61 39.61 0 0 0 7.26-.08v.1a36 36 0 0 1-3.89.21zM888.32 419.09c-1 0-2.13 0-3.32-.13v-.1a37.36 37.36 0 0 0 7.13-.08v.1a35 35 0 0 1-3.81.21zM888.49 420.58c-1.12 0-2.28-.05-3.62-.14v-.1a40.69 40.69 0 0 0 7.43 0v.1c-1.3.08-2.53.14-3.81.14zM888.31 420c-1.08 0-2.2 0-3.39-.13v-.1a39.92 39.92 0 0 0 7.37-.08v.1a37.25 37.25 0 0 1-3.98.21zM888.52 421.64a49.7 49.7 0 0 1-3.74-.15v-.1a44.15 44.15 0 0 0 7.74-.05v.1c-1.32.13-2.62.2-4 .2zM888.64 421.12c-1.19 0-2.43-.05-3.82-.16v-.09a42.75 42.75 0 0 0 7.62 0v.1c-1.25.08-2.44.15-3.8.15zM888.52 422.69c-1.24 0-2.52-.05-3.83-.14v-.1a48.19 48.19 0 0 0 8-.06v.1c-1.32.13-2.69.2-4.17.2zM888.05 422.14c-1.09 0-2.19 0-3.32-.12v-.1a45 45 0 0 0 7.86-.11v.1c-1.54.15-3.04.23-4.54.23zM888.9 423.77c-1.32 0-2.7-.06-4.31-.17v-.1a49.21 49.21 0 0 0 8.24 0v.1c-1.35.11-2.61.17-3.93.17zM888.53 423.21c-1.27 0-2.58 0-3.89-.14V423a48.61 48.61 0 0 0 8.12-.05v.1c-1.31.1-2.76.16-4.23.16zM889 424.72c-1.4 0-2.85-.06-4.44-.17v-.1a52.24 52.24 0 0 0 8.49 0v.1c-1.39.12-2.72.17-4.05.17zM888.93 424.2c-1.36 0-2.77-.06-4.37-.18v-.1a51.84 51.84 0 0 0 8.36 0v.1c-1.36.12-2.65.18-3.99.18zM888 425.73c-1.12 0-2.31 0-3.58-.13v-.1a55.1 55.1 0 0 0 8.72-.1v.1c-1.4.12-3.14.23-5.14.23zM889 425.25c-1.42 0-2.91-.06-4.49-.17V425a56.3 56.3 0 0 0 8.62 0v.1c-1.39.09-2.75.15-4.13.15zM888.27 426.27c-1.31 0-2.61 0-3.9-.14V426a57.17 57.17 0 0 0 8.86-.07v.1c-1.69.17-3.34.24-4.96.24zM889 427.36c-1.56 0-3.17-.06-4.76-.18v-.1a61.68 61.68 0 0 0 9.12 0v.1c-1.3.12-2.78.18-4.36.18zM888.33 426.8c-1.35 0-2.69-.05-4-.14v-.1a58.69 58.69 0 0 0 9-.07v.1c-1.69.14-3.33.21-5 .21zM889.51 428.44c-1.66 0-3.38-.06-5.32-.2v-.1a65.69 65.69 0 0 0 9.38.07v.1c-1.36.09-2.69.13-4.06.13zM889.45 427.92c-1.6 0-3.26-.07-5.21-.21v-.1a63.62 63.62 0 0 0 9.23.07v.1c-1.39.09-2.69.14-4.02.14zM889.59 429.5c-1.74 0-3.54-.07-5.49-.21v-.1a69.23 69.23 0 0 0 9.63.07v.1c-1.35.09-2.73.14-4.14.14zM889.55 429c-1.7 0-3.46-.07-5.4-.21v-.1a64.63 64.63 0 0 0 9.51.07v.1c-1.37.06-2.72.14-4.11.14zM889.82 430.45c-1.66 0-3.38-.07-5.31-.2v-.1a64.18 64.18 0 0 0 9.38.06v.1c-1.37.1-2.7.14-4.07.14zM889.92 429.94c-1.8 0-3.73-.07-5.86-.22v-.1a71.39 71.39 0 0 0 9.74.1v.1c-1.24.08-2.53.12-3.88.12zM890.36 431.54c-1.72 0-3.58-.08-5.81-.24v-.1a64.75 64.75 0 0 0 9.45.12v.1c-1.19.08-2.38.12-3.64.12zM889.11 430.94c-1.52 0-3-.06-4.6-.17v-.1a64.77 64.77 0 0 0 9.45 0v.09c-1.75.12-3.32.18-4.85.18zM890.39 432.6c-1.68 0-3.36-.08-5.67-.24v-.1a64.8 64.8 0 0 0 9.49.12v.1c-1.41.08-2.62.12-3.82.12zM890.31 432.07c-1.64 0-3.29-.07-5.59-.24v-.1a64.94 64.94 0 0 0 9.39.13v.14c-1.42 0-2.61.07-3.8.07zM889.86 433.68c-1.57 0-3.21-.06-5.27-.2v-.1a69.84 69.84 0 0 0 9.78.06v.1c-1.61.09-3.03.14-4.51.14zM890.44 433.13c-1.74 0-3.49-.08-5.79-.24v-.1a69.85 69.85 0 0 0 9.64.12v.1c-1.39.08-2.62.12-3.85.12zM889.93 434.64c-1.62 0-3.34-.06-5.42-.21v-.1a73.48 73.48 0 0 0 10 .07v.1c-1.57.08-3.03.14-4.58.14zM889.89 434.11c-1.59 0-3.27-.06-5.34-.21v-.1a71.42 71.42 0 0 0 9.88.07v.1c-1.59.08-3.02.14-4.54.14zM890.49 435.72c-1.91 0-3.85-.08-6.08-.24v-.1a78.89 78.89 0 0 0 10.27.12v.1c-1.44.08-2.81.12-4.19.12zM890.37 435.18c-1.86 0-3.73-.07-5.91-.22v-.1a76.68 76.68 0 0 0 10.14.1v.1c-1.48.08-2.85.12-4.23.12z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M844.7 197.6l-2.3-19.23.1-.01 2.3 19.23-.1.01z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M891.89 417.22h.1v19.56h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-5.8 -1492.506 792.523)'
        />
        <path
          d='M836.21 197.16h-.1l.08-19.19h.1l-.08 19.19zM836.87 197.13h-.1l.09-19.07h.1l-.09 19.07zM837.6 197.27h-.1l.14-19.21h.1l-.14 19.21z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M889.36 417.17h.1v19.19h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.57 -7857.4 2101.606)'
        />
        <path
          d='M838.47 178.06h.1v19.28h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M890.06 417.2h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-2.39 -4863.23 1486.276)'
        />
        <path
          d='M891.03 417.21h.1v19.48h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.12 -2456.795 990.611)'
        />
        <path
          d='M888.47 417.09h.1v19.3h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.81 -16046.754 3783.52)'
        />
        <path
          d='M881.89 400c-.7 0-1.44 0-2.25-.07v-.1a28.56 28.56 0 0 0 6.21-.22v.1a26.52 26.52 0 0 1-3.96.29zM881.91 399.44c-.68 0-1.41 0-2.24-.07v-.1a26.9 26.9 0 0 0 6-.21v.1a25.44 25.44 0 0 1-3.76.28zM881.83 401c-.72 0-1.47 0-2.26-.07v-.1a31.33 31.33 0 0 0 6.43-.22v.1a30.18 30.18 0 0 1-4.17.29zM881.85 400.48c-.71 0-1.45 0-2.24-.07v-.1a30.25 30.25 0 0 0 6.32-.22v.1a27.64 27.64 0 0 1-4.08.29zM882 402c-.77 0-1.58 0-2.48-.08v-.1a32.12 32.12 0 0 0 6.58-.19v.09a29.88 29.88 0 0 1-4.1.28zM881.8 401.42c-.72 0-1.47 0-2.25-.07v-.1a31.41 31.41 0 0 0 6.51-.23v.1a29.78 29.78 0 0 1-4.26.3zM882 403c-.8 0-1.62 0-2.5-.07v-.1a35.68 35.68 0 0 0 6.86-.21v.1a32.86 32.86 0 0 1-4.36.28zM882.08 402.48c-.81 0-1.67 0-2.59-.08v-.1a34.35 34.35 0 0 0 6.75-.19v.09a29.9 29.9 0 0 1-4.16.28zM881.89 404c-.81 0-1.65 0-2.5-.07v-.1a38 38 0 0 0 7.08-.21v.09a33.79 33.79 0 0 1-4.58.29zM881.56 403.5q-1 0-2.13-.06v-.1a36.14 36.14 0 0 0 7-.27v.1a36.45 36.45 0 0 1-4.87.33zM882.28 405.09c-.91 0-1.87 0-2.95-.09v-.1a39.52 39.52 0 0 0 7.29-.16v.1a37.74 37.74 0 0 1-4.34.25zM881.87 404.55c-.83 0-1.66 0-2.51-.07v-.1a38.32 38.32 0 0 0 7.19-.22v.1a34.88 34.88 0 0 1-4.68.29zM882.24 406c-.94 0-1.92 0-3-.09v-.09a44 44 0 0 0 7.52-.17v.1a40.26 40.26 0 0 1-4.52.25zM882.27 405.52c-.92 0-1.89 0-3-.1v-.1a40.87 40.87 0 0 0 7.41-.16v.1a39.1 39.1 0 0 1-4.41.26zM881.45 407.05c-.71 0-1.46 0-2.23-.06v-.1a44.46 44.46 0 0 0 7.72-.28v.1a47.17 47.17 0 0 1-5.49.34zM882.22 406.56q-1.43 0-3-.09v-.1a44.29 44.29 0 0 0 7.63-.17v.09a39.35 39.35 0 0 1-4.63.27zM881.63 407.58c-.82 0-1.63 0-2.45-.07v-.1a46.29 46.29 0 0 0 7.84-.25v.1a48.22 48.22 0 0 1-5.39.32zM882.15 408.64c-1 0-2 0-3-.09v-.1a48.47 48.47 0 0 0 8.07-.18v.1a44.44 44.44 0 0 1-5.07.27zM881.65 408.1c-.84 0-1.68 0-2.5-.07v-.1a46.39 46.39 0 0 0 8-.25v.1a48.58 48.58 0 0 1-5.5.32zM882.64 409.7c-1.13 0-2.3 0-3.58-.1v-.1a52.58 52.58 0 0 0 8.3-.13v.1a46.58 46.58 0 0 1-4.72.23zM882.65 409.18c-1.1 0-2.26 0-3.56-.11V409a48.63 48.63 0 0 0 8.16-.12v.1a45.08 45.08 0 0 1-4.6.2zM882.62 410.74c-1.15 0-2.35 0-3.62-.1v-.1a55.71 55.71 0 0 0 8.54-.13v.1c-1.6.16-3.21.23-4.92.23zM882.63 410.22c-1.14 0-2.33 0-3.6-.1V410a54 54 0 0 0 8.41-.13v.1a47.8 47.8 0 0 1-4.81.25zM882.63 411.69c-1.19 0-2.41 0-3.69-.11v-.1a55.67 55.67 0 0 0 8.73-.13v.1c-1.61.16-3.28.24-5.04.24zM882.92 411.18c-1.24 0-2.54 0-3.95-.12V411a56.55 56.55 0 0 0 8.63-.1v.1c-1.48.1-3.02.18-4.68.18zM883.09 412.75c-1.33 0-2.73 0-4.21-.13v-.1a59 59 0 0 0 8.92-.08v.1c-1.41.14-2.99.21-4.71.21zM881.94 412.19q-1.52 0-3-.09v-.1a57.26 57.26 0 0 0 8.83-.21v.1c-2.01.2-3.94.3-5.83.3zM883.09 413.8c-1.32 0-2.71-.05-4.27-.13v-.1a63.33 63.33 0 0 0 9.19-.08v.1c-1.67.14-3.24.21-4.92.21zM883.08 413.27c-1.3 0-2.67 0-4.23-.13V413a60.3 60.3 0 0 0 9.06-.07v.1c-1.66.18-3.19.24-4.83.24zM883.1 414.84c-1.37 0-2.8 0-4.34-.13v-.1a66.59 66.59 0 0 0 9.42-.08v.1c-1.68.14-3.33.21-5.08.21zM883.1 414.32c-1.35 0-2.76-.05-4.31-.13v-.1a65 65 0 0 0 9.31-.08v.1c-1.68.14-3.29.21-5 .21zM883.1 415.78c-1.41 0-2.87 0-4.4-.13v-.1a69.31 69.31 0 0 0 9.61-.08v.1c-1.66.14-3.39.21-5.21.21zM883.1 415.26c-1.39 0-2.83-.05-4.37-.13V415a67.71 67.71 0 0 0 9.5-.08v.1c-1.66.17-3.35.24-5.13.24zM883.62 416.84c-1.56 0-3.23 0-5-.15v-.1a72.6 72.6 0 0 0 9.84 0v.09c-1.46.1-3.08.16-4.84.16zM883.54 416.32c-1.52 0-3.14-.05-4.87-.15v-.1a70.91 70.91 0 0 0 9.73 0v.1c-1.5.08-3.12.15-4.86.15z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M886.58 398.66h.1v19.11h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-7.17 -1045.603 681.043)'
        />
        <path
          d='M885.85 398.56h.1v19.31h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-6.26 -1325.017 737.978)'
        />
        <path
          d='M830.74 178.54l-.03-19.1h.1l.03 19.1h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M880.57 398.58h.1v18.95h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.13 -104470.809 21966.82)'
        />
        <path
          d='M881.34 398.58h.1v18.94h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.31 -43335.624 9369.884)'
        />
        <path
          d='M834.85 178.47l-.82-18.94.1-.01.82 18.95h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M882.14 398.57h.1v18.99h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.75 -17403.63 4044.356)'
        />
        <path
          d='M884.23 398.57h.1v19.1h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-3.2 -3419.327 1168.519)'
        />
        <path
          d='M885.09 398.57h.1v19.24h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.75 -2021.615 881.154)'
        />
        <path
          d='M882.88 398.47h.1v19.09h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.41 -8856.222 2285.496)'
        />
        <path
          d='M888.2 417.92l-2.2-18.13c-.07-.79-.94-.92-1.66-.9l-6-.2v-.57l6 .19c1.89-.05 2.19 1 2.23 1.42l2.19 18.13z'
          style={{
            fill: 'url(#s-68ff652d2d-aU)',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M888.91 419.25l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M889.37 420.54l-2.19-18.13a1.32 1.32 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M889.87 422.15L887.68 404a1.31 1.31 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.22 18.16z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M890.32 423.29l-2.19-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M890.79 424.63l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2V405l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M891.25 426l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.15z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M891.76 427.6l-2.2-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2V408l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M892.24 429l-2.19-18.13a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M892.72 430.45l-2.2-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.33 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M893.19 431.88L891 413.75a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M893.7 433.62l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2V414l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M894.17 435L892 416.82a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M894.44 436.56l-2.2-18.13a1.07 1.07 0 0 0-1-1l-6.38-.2v-.57l6.39.2a1.64 1.64 0 0 1 1.56 1.49l2.19 18.14z'
          style={{
            fill: 'url(#s-68ff652d2d-aV)',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M882.84 397.94h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.86 97.46 444.474)'
        />
        <path
          d='M883.99 398.05h.1v19.37h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.47 81.533 448.194)'
        />
        <path
          d='M838.81 178.07l-5.71-18.56.1-.03 5.7 18.56-.09.03zM840.1 178.07l-6.09-18.62.1-.03 6.09 18.62-.1.03zM841.16 178.07l-6.3-18.52.09-.03 6.31 18.52-.1.03z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M888.29 398.19h.1v19.52h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-18.69 137.652 437.853)'
        />
        <path
          d='M884.59 437.59a.57.57 0 0 1-.59-.59v-20.09l-4.71-14.73v16.46a.58.58 0 0 1-1.15 0v-20.11a.57.57 0 0 1 1.12-.18l5.83 18.21a.64.64 0 0 1 0 .24V437a.56.56 0 0 1-.5.59z'
          style={{
            fill: 'url(#s-68ff652d2d-aW)',
          }}
          transform='translate(-49.16 -239.04)'
        />
      </g>
      <g
        id='unihockeyLeft'
      >
        <path
          d='M192.93 164.46l-44.43-2.59 41.58-26.27 40.87 2.72-38.02 26.14z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M221.52 393.89l-11.92-.75v-1.09l20.86-12.44a3 3 0 0 1 2-.41l9.5 1.29v1.09l-9.22-.58a3.1 3.1 0 0 0-1.81.45l-16.69 10.12 7.26 1.23z'
          style={{
            fill: 'url(#s-68ff652d2d-aX)',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M221.37 392.8l-11.77-.75 21-12.51a3.11 3.11 0 0 1 1.79-.43l10.11.64-.45.58a.39.39 0 0 1-.33.15l-9.14-.58a3.11 3.11 0 0 0-1.79.43l-18.6 11.1 10.39.66-.93.64a.45.45 0 0 1-.28.07z'
          style={{
            fill: 'url(#s-68ff652d2d-aY)',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M241.29 360.39a26.14 26.14 0 0 1-5.79-.58v-.11a26.75 26.75 0 0 0 6.24.58v.11zM241.25 359.81a23.81 23.81 0 0 1-5.5-.56v-.11a24.6 24.6 0 0 0 6 .56v.11zM241.34 361.55a28.37 28.37 0 0 1-6.06-.6v-.11a28.19 28.19 0 0 0 6.47.6v.11zM241.33 361a27.32 27.32 0 0 1-5.94-.59v-.11a27.15 27.15 0 0 0 6.35.59v.11zM241.26 362.6a29.2 29.2 0 0 1-6.13-.58v-.11a28.84 28.84 0 0 0 6.62.58v.11zM241.35 362a28.66 28.66 0 0 1-6.16-.61v-.11a29 29 0 0 0 6.56.61v.11zM241.31 363.77a31.43 31.43 0 0 1-6.46-.61v-.11a31.94 31.94 0 0 0 6.9.61v.1zM241.27 363.19a30.22 30.22 0 0 1-6.31-.59v-.1a31.06 31.06 0 0 0 6.79.57v.11zM241.36 364.93a34 34 0 0 1-6.74-.63v-.1a35.59 35.59 0 0 0 7.13.62v.11zM241.42 364.35a33 33 0 0 1-6.67-.68v-.11a32.64 32.64 0 0 0 7 .68v.11zM241.21 366.09a35.75 35.75 0 0 1-6.8-.58v-.11a36.22 36.22 0 0 0 7.35.58v.11zM241.37 365.51a35.15 35.15 0 0 1-6.86-.64v-.1a36 36 0 0 0 7.24.63v.11zM241.27 367.14a37.78 37.78 0 0 1-7.09-.6v-.1a39.22 39.22 0 0 0 7.57.59v.11zM241.23 366.56a36.23 36.23 0 0 1-6.93-.59v-.11a37.25 37.25 0 0 0 7.46.59v.11zM241.46 368.31a40.49 40.49 0 0 1-7.48-.74v-.11a40.85 40.85 0 0 0 7.77.74v.1zM241.28 367.73a39.88 39.88 0 0 1-7.21-.61v-.11a39.5 39.5 0 0 0 7.68.6v.11zM241.42 368.89a41.59 41.59 0 0 1-7.56-.71v-.11a41.69 41.69 0 0 0 7.89.71v.11zM241.35 370.05a45.44 45.44 0 0 1-7.73-.64v-.11a45.14 45.14 0 0 0 8.13.64v.11zM241.42 369.47a43.27 43.27 0 0 1-7.67-.71v-.11a43.31 43.31 0 0 0 8 .71v.11zM241.19 371.21a46.86 46.86 0 0 1-7.81-.59v-.11a46.78 46.78 0 0 0 8.37.59v.11zM241.14 370.63a44.71 44.71 0 0 1-7.61-.58v-.11a44.42 44.42 0 0 0 8.23.58v.11zM241.22 372.38a49.72 49.72 0 0 1-8.06-.61v-.11a50.45 50.45 0 0 0 8.6.61v.1zM241.21 371.8a48.26 48.26 0 0 1-7.94-.6v-.11a48.05 48.05 0 0 0 8.48.59v.11zM241.24 373.43a52.44 52.44 0 0 1-8.29-.62v-.11a52.76 52.76 0 0 0 8.8.62v.11zM241.15 372.85a49.24 49.24 0 0 1-8.09-.59v-.1a51.75 51.75 0 0 0 8.69.58v.1zM241.14 374.59a53 53 0 0 1-8.39-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM241.38 374a52.65 52.65 0 0 1-8.52-.71v-.11a53 53 0 0 0 8.9.71v.11zM241.09 375.75a55.6 55.6 0 0 1-8.6-.59v-.1a57.14 57.14 0 0 0 9.26.58v.11zM241.07 375.17a55.08 55.08 0 0 1-8.45-.58v-.11a55.5 55.5 0 0 0 9.13.58v.11zM241.14 376.92a59 59 0 0 1-8.88-.61v-.1a61.27 61.27 0 0 0 9.49.6v.1zM241.12 376.34a58.55 58.55 0 0 1-8.74-.6v-.11a58.69 58.69 0 0 0 9.38.59v.11zM241.18 378a62 62 0 0 1-9.12-.62v-.11a63.84 63.84 0 0 0 9.69.62v.11zM241.16 377.39a61.68 61.68 0 0 1-9-.61v-.11a62.42 62.42 0 0 0 9.58.61v.1zM241.08 379.13a64.42 64.42 0 0 1-9.25-.58v-.11a66.45 66.45 0 0 0 9.93.58v.11zM241.08 378.55a63.49 63.49 0 0 1-9.14-.58v-.11a63.89 63.89 0 0 0 9.81.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M183.39 140.47l-.11-.02 3.93-20.78.11.02-3.93 20.78zM184.28 140.47l-.1-.02 3.74-20.85.11.02-3.75 20.85zM191.29 141.01h-.11l.16-21.25.11.01-.16 21.24z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M229.22 369.29h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 94.159 274.567)'
        />
        <path
          d='M189.79 140.85h-.11l.44-21.1.11.01-.44 21.09zM187.15 140.71l-.11-.02 2.28-21.08.1.01-2.27 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M228.16 369.22h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.3 89.88 274.743)'
        />
        <path
          d='M226.25 369.08h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 77.035 277.428)'
        />
        <path
          d='M225.48 369.04h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 72.273 278.187)'
        />
        <path
          d='M188.21 140.7l-.11-.01 1.45-21.08.11.01-1.45 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M231.94 379.56l-.61-.12 3.88-19.75a1.66 1.66 0 0 1 1.74-1.34l5.34.31v.62l-5.34-.31a1 1 0 0 0-1.1.84z'
          style={{
            fill: 'url(#s-68ff652d2d-aZ)',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M217.04 364.93h24.01v.08h-24.01z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -228.42 337.885)'
        />
        <path
          d='M213.65 364.9h24.47v.08h-24.47z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.58 -235.89 335.323)'
        />
        <path
          d='M168.86 131.98l-.04-.07 20.53-12.33.04.07-20.53 12.33zM168.17 131.86l-.04-.07 20.27-12.17.04.07-20.27 12.17zM167.19 131.98l-.04-.07 20.6-12.33.04.07-20.6 12.33z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M237.52 357.47h.08v3.27h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86.86 86.74 265.557)'
        />
        <path
          d='M236.63 358.25h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.7 68.904 269.578)'
        />
        <path
          d='M188.13 121.33l-2.54-.63.01-.07 2.55.63-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M235.36 359.22h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.96 36.793 276.67)'
        />
        <path
          d='M234.75 359.59h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.46 34.542 277.382)'
        />
        <path
          d='M218.78 368.43h.08v4.01h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-85.98 66.04 277.282)'
        />
        <path
          d='M219.55 368.1h.08v3.47h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-84.68 63.819 277.286)'
        />
        <path
          d='M220.46 367.69h.08v3.21h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.67 57.612 278.211)'
        />
        <path
          d='M221.29 367.24h.08v3.11h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.3 55.051 278.416)'
        />
        <path
          d='M181.43 125.38l-3.04-.43.01-.07 3.04.43-.01.07zM182.33 124.84l-3.02-.43.02-.08 3.01.44-.01.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M222.25 366.67h.08v3.09h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.34 56.143 277.822)'
        />
        <path
          d='M223.07 366.27h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 50.914 278.566)'
        />
        <path
          d='M223.88 365.73h.08v3.04h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.91 56.66 277.068)'
        />
        <path
          d='M224.7 365.31h.08v2.91h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 52.569 277.595)'
        />
        <path
          d='M177.73 127.61l-2.87-.57.01-.08 2.88.58-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M226.32 364.27h.08v3.03h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.8 59.952 273.95)'
        />
        <path
          d='M233.58 359.87h.08v3.2h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.2 66.726 272.433)'
        />
        <path
          d='M186.23 122.47l-2.44-.71.02-.07 2.44.71-.02.07zM185.13 123.14l-2.76-.54.02-.07 2.76.54-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M232.14 360.91h.08v2.77h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.21 63.163 272.486)'
        />
        <path
          d='M231.44 361.34h.08v2.8h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.13 59.664 273.51)'
        />
        <path
          d='M230.77 361.74h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-77.77 58.026 274.094)'
        />
        <path
          d='M228.39 363.09h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.64 60.505 274.52)'
        />
        <path
          d='M179.91 126.3l-2.84-.57.02-.08 2.83.57-.01.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M227.05 363.98h.08v2.76h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-75.78 48.946 277.434)'
        />
        <path
          d='M209.27 384.65h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -238.3 354.63)'
        />
        <path
          d='M209.3 384.07h24.27v.11H209.3z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -238.277 354.05)'
        />
        <path
          d='M209.45 383.45h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -238.13 353.443)'
        />
        <path
          d='M209.63 382.91h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.94 352.89)'
        />
        <path
          d='M209.66 382.33h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.916 352.308)'
        />
        <path
          d='M209.82 381.71h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.751 351.707)'
        />
        <path
          d='M209.88 381.21h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.69 351.196)'
        />
        <path
          d='M210.1 380.69h24.27v.11H210.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.485 350.665)'
        />
        <path
          d='M210.13 380.11h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.444 350.089)'
        />
        <path
          d='M210.28 379.49h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.297 349.483)'
        />
        <path
          d='M210.47 378.95h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.106 348.929)'
        />
        <path
          d='M210.5 378.36h24.27v.11H210.5z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.083 348.348)'
        />
        <path
          d='M210.65 377.75h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.936 347.742)'
        />
        <path
          d='M210.71 377.25h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.856 347.236)'
        />
        <path
          d='M210.81 376.68h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.76 346.675)'
        />
        <path
          d='M210.84 376.1h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.738 346.094)'
        />
        <path
          d='M211 375.48h24.27v.11H211z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.586 345.47)'
        />
        <path
          d='M211.18 374.94h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.4 344.934)'
        />
        <path
          d='M211.21 374.36h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.377 344.353)'
        />
        <path
          d='M211.36 373.74h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.207 343.734)'
        />
        <path
          d='M211.42 373.24h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.15 343.24)'
        />
        <path
          d='M211.6 372.57h24.27v.11H211.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -236.325 343.185)'
        />
        <path
          d='M211.76 371.96h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.813 341.943)'
        />
        <path
          d='M211.94 371.41h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.645 341.402)'
        />
        <path
          d='M211.97 370.83h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.604 340.826)'
        />
        <path
          d='M212.13 370.21h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.452 340.202)'
        />
        <path
          d='M212.19 369.72h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.395 339.709)'
        />
        <path
          d='M212.29 369.15h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -235.636 339.747)'
        />
        <path
          d='M212.31 368.57h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -235.596 339.17)'
        />
        <path
          d='M212.47 367.95h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.107 337.948)'
        />
        <path
          d='M212.65 367.41h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.916 337.394)'
        />
        <path
          d='M212.68 366.83h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.893 336.813)'
        />
        <path
          d='M212.84 366.21h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.746 336.207)'
        />
        <path
          d='M212.9 365.71h24.27v.11H212.9z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.684 335.695)'
        />
        <path
          d='M203.39 381.02h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 43.48 291.518)'
        />
        <path
          d='M204.56 380.3h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 44.646 290.793)'
        />
        <path
          d='M203.96 380.69h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 44.051 291.182)'
        />
        <path
          d='M205.07 380.02h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 45.161 290.513)'
        />
        <path
          d='M206.24 379.3h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 46.327 289.788)'
        />
        <path
          d='M205.64 379.68h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 45.733 290.176)'
        />
        <path
          d='M206.75 379.02h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 47.732 290.24)'
        />
        <path
          d='M207.92 378.3h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 48.004 288.788)'
        />
        <path
          d='M207.32 378.68h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 47.41 289.177)'
        />
        <path
          d='M208.43 378.01h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 48.52 288.508)'
        />
        <path
          d='M209.6 377.29h20.58v.11H209.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 49.692 287.787)'
        />
        <path
          d='M209 377.68h20.58v.11H209z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 49.091 288.171)'
        />
        <path
          d='M210.12 377.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 50.202 287.564)'
        />
        <path
          d='M211.29 376.35h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 51.374 286.843)'
        />
        <path
          d='M210.69 376.73h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 50.779 287.221)'
        />
        <path
          d='M211.8 376.07h20.58v.11H211.8z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 51.89 286.563)'
        />
        <path
          d='M212.97 375.34h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 53.056 285.838)'
        />
        <path
          d='M212.37 375.73h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 52.467 286.22)'
        />
        <path
          d='M213.49 375.08h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 53.573 285.568)'
        />
        <path
          d='M214.65 374.35h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 54.745 284.848)'
        />
        <path
          d='M214.06 374.74h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 54.144 285.232)'
        />
        <path
          d='M215.17 374.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 55.254 284.563)'
        />
        <path
          d='M216.34 373.35h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 56.427 283.842)'
        />
        <path
          d='M215.74 373.73h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 55.832 284.231)'
        />
        <path
          d='M216.85 373.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 56.942 283.562)'
        />
        <path
          d='M218.02 372.35h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 58.109 282.837)'
        />
        <path
          d='M217.42 372.73H238v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 57.514 283.226)'
        />
        <path
          d='M218.53 372.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 59.53 283.239)'
        />
        <path
          d='M219.7 371.34h20.58v.11H219.7z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 60.697 282.508)'
        />
        <path
          d='M219.1 371.73h20.58v.11H219.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 59.196 282.22)'
        />
        <path
          d='M220.22 371.12h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 60.306 281.612)'
        />
        <path
          d='M221.39 370.4h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 62.393 281.556)'
        />
        <path
          d='M220.79 370.78h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 60.878 281.276)'
        />
        <path
          d='M221.9 370.12h20.58v.11H221.9z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 61.988 280.607)'
        />
        <path
          d='M222.47 369.78h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 62.56 280.27)'
        />
        <path
          d='M220.61 372.7a25.42 25.42 0 0 1-5.79-.59v-.1a26.24 26.24 0 0 0 6.24.57v.11zM220.55 372.11a23.72 23.72 0 0 1-5.49-.56v-.1a24.13 24.13 0 0 0 6 .55v.11zM220.65 373.86a27.73 27.73 0 0 1-6.06-.61v-.1a28.76 28.76 0 0 0 6.47.6v.11zM220.64 373.28a26.7 26.7 0 0 1-5.94-.6v-.1a28.27 28.27 0 0 0 6.35.59v.1zM220.57 374.91a29.2 29.2 0 0 1-6.13-.58v-.11a30 30 0 0 0 6.62.58v.11zM220.67 374.33a29.34 29.34 0 0 1-6.17-.61v-.11a29.56 29.56 0 0 0 6.56.61v.1zM220.62 376.07a31.43 31.43 0 0 1-6.46-.61v-.1a32 32 0 0 0 6.9.6v.11zM220.58 375.49a30.93 30.93 0 0 1-6.31-.58v-.11a31.66 31.66 0 0 0 6.79.58v.11zM220.67 377.23a34.8 34.8 0 0 1-6.74-.62v-.11a34.18 34.18 0 0 0 7.13.62v.11zM220.73 376.65a33 33 0 0 1-6.67-.67v-.11a33.27 33.27 0 0 0 7 .67v.11zM220.52 378.4a35.75 35.75 0 0 1-6.8-.58v-.11a36.79 36.79 0 0 0 7.34.58v.11zM220.68 377.82a35.15 35.15 0 0 1-6.86-.64v-.11a35.86 35.86 0 0 0 7.24.64v.1zM220.58 379.45a38.64 38.64 0 0 1-7.09-.6v-.11a39.13 39.13 0 0 0 7.57.6v.11zM220.54 378.87a37.06 37.06 0 0 1-6.93-.59v-.11a37.83 37.83 0 0 0 7.45.59v.1zM220.77 380.61a41.5 41.5 0 0 1-7.48-.73v-.11a41 41 0 0 0 7.77.73v.11zM220.59 380a39 39 0 0 1-7.21-.61v-.11a40.27 40.27 0 0 0 7.68.61v.11zM220.73 381.19a42.46 42.46 0 0 1-7.56-.7v-.11a42.5 42.5 0 0 0 7.89.7v.11zM220.65 382.36a44.29 44.29 0 0 1-7.72-.65v-.1a46.07 46.07 0 0 0 8.13.64v.1zM220.73 381.77a42.35 42.35 0 0 1-7.67-.71v-.1a43.21 43.21 0 0 0 8 .7v.11zM220.5 383.52a46.86 46.86 0 0 1-7.81-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM220.45 382.94a44.79 44.79 0 0 1-7.61-.58v-.11a46.22 46.22 0 0 0 8.23.58v.11zM220.54 384.68a48.66 48.66 0 0 1-8.07-.61V384a50.49 50.49 0 0 0 8.6.6v.11zM220.52 384.1a48.26 48.26 0 0 1-7.94-.6v-.11a49.05 49.05 0 0 0 8.48.6v.11zM220.55 385.73a51.28 51.28 0 0 1-8.29-.62V385a50.78 50.78 0 0 0 8.8.62v.11zM220.46 385.15a49.32 49.32 0 0 1-8.09-.58v-.11a50.72 50.72 0 0 0 8.69.58v.11zM220.45 386.9a52.89 52.89 0 0 1-8.39-.59v-.1a54.54 54.54 0 0 0 9 .57v.11zM220.69 386.31a52.65 52.65 0 0 1-8.52-.71v-.11a53 53 0 0 0 8.9.71v.11zM220.41 388.06a57 57 0 0 1-8.61-.59v-.11a58.24 58.24 0 0 0 9.26.59v.11zM220.38 387.48a55.08 55.08 0 0 1-8.45-.58v-.11a56.62 56.62 0 0 0 9.13.58v.11zM220.45 389.22a60.15 60.15 0 0 1-8.87-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM220.43 388.64a57.24 57.24 0 0 1-8.74-.6v-.1a59.88 59.88 0 0 0 9.38.59v.11zM220.49 390.27a63.43 63.43 0 0 1-9.12-.61v-.11a62.63 62.63 0 0 0 9.69.61v.11zM220.48 389.69a60.45 60.45 0 0 1-9-.61v-.11a62.5 62.5 0 0 0 9.58.61v.11zM220.4 391.44a64.44 64.44 0 0 1-9.26-.59v-.1a66.56 66.56 0 0 0 9.93.57v.11zM220.39 390.85a63.49 63.49 0 0 1-9.14-.58v-.11a63.89 63.89 0 0 0 9.81.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M162.7 152.77l-.11-.02 3.93-20.77.11.02-3.93 20.77zM163.59 152.77l-.1-.02 3.74-20.84.11.02-3.75 20.84zM170.6 153.31h-.11l.16-21.24h.11l-.16 21.24z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M208.53 381.6h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 73.477 286.852)'
        />
        <path
          d='M169.1 153.16h-.11l.44-21.1h.11l-.44 21.1zM166.46 153.01l-.11-.01 2.28-21.09.11.01-2.28 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M207.47 381.52h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 69.794 287.477)'
        />
        <path
          d='M205.56 381.38h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 56.346 289.73)'
        />
        <path
          d='M204.79 381.35h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 51.582 290.486)'
        />
        <path
          d='M167.52 153.01l-.11-.01 1.45-21.09.11.01-1.45 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M211.1 391.89l-.61-.12 3.88-19.77a1.68 1.68 0 0 1 1.74-1.35l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.09.85z'
          style={{
            fill: 'url(#s-68ff652d2d-ba)',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M221.59 393.74l-1-.41.07-22.07a1.55 1.55 0 0 1 .75-1.32l20.16-12.17a.34.34 0 0 1 .31 0l.75.22a.39.39 0 0 1 .28.39l-.91 23.2-.94-.06v-21.67a.38.38 0 0 0-.58-.33l-18.12 10.94a1.55 1.55 0 0 0-.75 1.33z'
          style={{
            fill: 'url(#s-68ff652d2d-bb)',
          }}
          transform='translate(-49.16 -239.04)'
        />
        <path
          d='M221.8 393.61l-.28.28.07-22.1a1.55 1.55 0 0 1 .75-1.33l20-12.06a.39.39 0 0 1 .59.33v20.63a3.13 3.13 0 0 1-.91 2.2v-21.2a.39.39 0 0 0-.59-.33L223.27 371a1.57 1.57 0 0 0-.75 1.33v19.54a2.51 2.51 0 0 1-.72 1.74z'
          style={{
            fill: 'url(#s-68ff652d2d-bc)',
          }}
          transform='translate(-49.16 -239.04)'
        />
      </g>
    </g>
  </Fragment>
)

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: '&&& path, &&& use, &&& g',
  size: null
}

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    })
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name]
    if (typeof prop !== 'object') { return }
    for (let key in prop) {
      if (!prop[key] || typeof prop[key].width !== 'number' || typeof prop[key].height !== 'number') {
        return new Error(
          'Invalid prop `' + name + '` supplied to `' + componentName + '`. Validation failed.'
        )
      }
    }
  }
}

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: '32x15'
})
